export const locale = {
  general_menu_settings: '菜单常规设置',
  settings: {
  business_type_title: '選擇菜單業務類型',
  currency_label: '貨幣',
  show_filter: '顯示產品過濾器',
  show_categories: '顯示產品類別',
  
  business_types: {
    cafe: '咖啡館',
    restaurant: '餐廳',
    fastfood: '快餐',
    icecream: '果汁與冰淇淋',
    sweets: '糖果與甜點',
    bakery: '麵包店'
  },
  
  custom_labels: {
        ph_menu_cafe: '咖啡廳菜單',
    ph_menu_restaurant: '餐飲菜單',
    ph_menu_fastfood: '速食菜單', 
    ph_menu_icecream: '果汁與冰淇淋',
    ph_menu_sweets: '蛋糕與甜點',
    ph_menu_bakery: '麵包與烘焙',
    ph_product_list: '產品',
    ph_add_order: '新增',
    ph_add_cart: '購買',

    title: '自定義標籤（可選）',
    subtitle: '用您喜歡的詞語替換默認的系統術語。',
    products_title: '產品部分標題',
    ph_food_menu: '例如：食品菜單',
    ph_product_list: '例如：產品列表',
    cart_btn: '結帳按鈕文本',
    ph_add_order: '例如：添加到訂單',
    ph_add_cart: '例如：添加到購物車'
  },

  currencies: {
    toman: '土曼',
    rial: '里亞爾'
  }
},
check_account_balance_and_try_again: '請檢查您的帳戶餘額後再試一次',
problem_with_qr_renewal_request: '提交 QR Code 續期申請時發生問題',

  ERRORS: {
    PhoneIsNotValid: "輸入的電話號碼無效：例如 09101234567",
    InvalidNumber: "輸入的數量無效。",
    NoSelectedLineNumber: "請選擇傳送線路。",
    EmptyText: "請輸入文字。",
    UnknownError: "未知錯誤",
    TryAgain: "請稍後再試。",
    NoAccountCharge: "餘額不足",
    NoAccess: "拒絕存取。",
    PleasebyeAPlane: "請購買方案。",
    PleaseChargeYourAccount: "請儲值您的帳戶。",
    AccessDenied: "拒絕存取。",
    AccessDeniedDescription: "請聯絡客服以獲取更多資訊。",
    Error: "錯誤",
    InvalidText: "無效文字",
    InvalidTextContainsLink: "只有服務線路可以包含連結。",
    NoPhoneToSend: "沒有可傳送的號碼。",
  },
  FORMS: {
    SuccsessFullySended: "知道了",
    DestinationPhone: "收件人號碼",
    TestDestinationPhone: "測試電話號碼",
    SourceNumber: "寄件人號碼",
    Text: "文字",
    CharCount: "字元數",
    FarsiCharCount: "波斯語字元數",
    EnglishCharCount: "英文字元數",
    Send: "傳送",
    SendTime: "傳送時間",
    SendTest: "測試傳送",
    SendToTestNumber: "傳送至測試號碼",
    SmsCount: "簡訊數量",
    SmsLang: "簡訊語言",
    Add: "新增",
    FromFile: "從檔案新增",
    TestNumber: "測試號碼",
    Test: "測試",
    ServiceRelated: "服務相關",
    Price: "白名單傳送費用",
    TotalPrice: "總費用",
    NumbersCount: "總號碼數",
    BlacklistPrice: "黑名單傳送費用",
    BlacklistNumbersCount: "黑名單數量",
    WhitelistNumbersCount: "白名單數量",
    IrancellNumbersBlacklistCount: "Irancell 黑名單數量",
    HamrahavalNumbersBlacklistCount: "Hamrah Aval 黑名單數量",
    IrancellNumbersWhitelistCount: "Irancell 白名單數量",
    HamrahavalNumbersWhitelistCount: "Hamrah Aval 白名單數量",
    NumbersCountToSend: "有效號碼數量",
    Search: "搜尋",
    Title: "標題",
    RequestTime: "請求時間",
    RequestInformation: "請求資訊",
    CreateNewPhoneBook: "建立新電話簿",
    AddPhone: "新增號碼",
    Remove: "移除",
  },
  unexpected_error: "發生了意外錯誤，請再試一次。",
  luck_wheel_name: "幸運轉盤二維碼名稱",
  update_video: "新增影片畫廊",
  edit: "編輯",
  to_top: "從上方",
  to_bottom: "從下方",
  to_left: "從右到左",
  to_right: "從左到右",
  to_top_right: "從下方到右",
  to_top_left: "從下方到左",
  to_bottom_right: "從上方到右",
  to_bottom_left: "從上方到左",
  select_color_gradient: "選擇漸層顏色",
  select_color_solid: "選擇純色",
  gradient_direction: "漸層方向",
  gradient_background: "漸層背景",
  qr_downloaded_successfully: "QR碼已成功下載。",
  logo: "標誌",
  qr_design_size: "QR碼設計與尺寸",
  qr_eye_design: "QR碼眼部設計",
  qr_markout: "輸出邊距",
  frame: "邊框",
  ready_card_samples: "現成名片範例",
  ready_card_sample: "現成名片範例",
  remove_default_info: "移除預設資訊",
  select_ready_card: "選擇現成名片",
  connection_code: "連接碼",
  enter_visit_card_info: "輸入名片資訊",
  info: "資訊",
  select_template_design: "選擇模板設計",
  qr_address: "QR碼網址",
  visit_card_name: "您的名片名稱",
  visit_card_name_pro: "您的名片名稱",
  download_qr: "下載QR碼",
  fast_design: "快速設計",
  professional_design: "專業設計",
  ai_design: "人工智慧設計",
  update_qr: "更新QR碼",
  fast_design_message: "您已切換至快速碼設計。先前設計已於本區完成。",
  professional_design_message: "您已切換至專業碼設計。先前設計已於本區完成。",
  scan_me: "掃描我",
  visit_card_edited_successfully: "您的名片已成功編輯。",
  customer_club_membership: "客戶俱樂部會員",
  qrland: "QR樂園",
  dynamic: "動態",
  about_us_text:
    "動態QR碼特色：\n✔️ 無限編輯\n✔️ 輕鬆掃描\n✔️ 可限制掃描次數\n✔️ 可加入密碼\n✔️ 查看訪客統計\n✔️ 變更顏色與外觀\n✔️ 資料與安全保護\n✔️ 可加入圖片與標誌\n✔️ 依業務需求製作專屬QR碼\n✔️ 導向連結與網站\n✔️ 同時提供QR碼與短網址\n✔️ 適用於所有社群平台（離線/線上）\n✔️ 可下載任意格式\n✔️ 可列印於任何材質與尺寸",
  video_gallery: "影片藝廊",
  address_text: "台北市中山區中山北路二段，過中山橋後，巷弄6號",
  visit_card: "名片",
  qrland_system: "QR樂園系統",
  qrland_first_system: "首個動態QR碼生成系統",
  address: "地址",
  enter_site_link: "輸入您想要的網站連結",
  instagram: "Instagram",
  enter_instagram_username: "輸入您的使用者名稱",
  whatsapp: "WhatsApp",
  invalid_qr_address: "輸入的網址無效！",
  visit_card_created_successfully: "您的名片已成功建立。",
  qr_creation_failed: "QR碼建立失敗！",
  manage_password: "密碼管理",
  hour_limit: "時間限制",
  scan_click_limit: "掃描/點擊次數限制",
  redirect_scanner: "重新導向掃描者",
  edit_settings_error: "編輯設定時發生錯誤！",
  next: "下一步",
  add: "新增",
  header_color_settings: "頁首顏色與文字設定",
  select_image: "選擇圖片",
  enter_qr_address: "輸入您的QR碼網址",
  qr_idea_title: "QR碼創作構想",
  qr_idea: "QR構想",
  qr_idea_subject: "QR創作主題",
  confirm_qr_idea: "確認我的QR構想",
  scannable: "可掃描",
  ai_sample: "人工智慧生成範例...",
  scan_warning: "可能無法在所有裝置上掃描。若無法掃描，請重新嘗試。",
  ai_description: "輸入您想要的QR碼描述，人工智慧將為您生成。",
  attach: "附加",
  remaining: "剩餘",
  qr_creation: "QR碼生成",
  free: "免費",
  select_language_for_request: "選擇請求文字語言",
  request_text: "請求文字",
  request_text_placeholder: "描述您想要的QR連結...",
  strengthen_text: "強化現有文字",
  prompt_idea: "提示構想",
  try_again: "再次嘗試",
  create_qr: "建立QR碼",
  smart_qr_code: "智慧型QR碼",
  regenerate_image: "重新生成圖片",
  updating_qr: "正在更新QR碼...",
  copied: "已複製",
  copy: "複製",
  print_qr: "列印QR碼",
  print_visit_card: "列印名片",
  send_link: "傳送連結",
  customer_list: "客戶清單",
  order_list: "訂單清單",
  reserved_appointments: "已預約時段",
  feedback: "意見回饋",
  request_form: "請求表單",
  transfer_ownership: "轉移所有權",
  select_nfc_card: "選擇NFC卡",
  created_at: "建立於",
  last_edit: "最後編輯",
  qr_card: "QR卡",
  viewed: "已檢視",
  see_more: "檢視更多",
  download: "下載",
  activate: "啟用",
  design: "設計",
  qr_settings: "QR設定",
  deactivate: "停用",
  qr_color_size: "QR顏色與尺寸",
  dots_design_color: "點陣設計與顏色",
  eye_design_color: "眼部設計與顏色",
  border_design_color: "邊框設計與顏色",
  logo_settings: "標誌設定",
  download_qr_comment: "下載QR碼",
  connection_established: "連線已建立。",
  show_qr: "顯示QR碼",
  preview: "預覽",
  user_info: "使用者資訊",
  sms_club_membership: "簡訊俱樂部會員",
  smart_settings: "智慧設定",
  add_audio_file: "新增音訊檔案",
  back: "返回",
  after_click_location: "點擊位置後，選擇您的地圖應用程式。",
  phone_number: "電話號碼",
  auto_display: "自動顯示",
  customer_club: "客戶俱樂部",
  auto_download: "自動下載",
  save: "儲存",
  about_us: "關於我們",
  view_more: "檢視更多",
  view_less: "檢視較少",
  audio_file: "音訊檔案",
  add_video: "新增影片",
  add_image: "新增圖片",
  select_color: "選擇顏色",
  header_color: "頁首文字",
  add_social_networks: "新增社群網路",
  format: "格式",
  output_size: "輸出尺寸",
  file_type: "檔案類型",
  default: "預設",
  qr_download_error: "下載QR碼時發生問題。請重新嘗試",
  header_color_text_settings: "頁首顏色與文字設定",
  upload_catalog_images: "上傳型錄/手冊圖片",
  delete: "刪除",
  personal_domain: "個人網域",
  no_domain_found: "未找到網域！",
  enter_domain_address: "請輸入您的網域地址",
  dns_setup_note: "請記得先設定伺服器DNS！",
  attention: "注意：",
  dns_setup_instruction: "要註冊個人網域，請先設定DNS",
  and: "與",
  setup_on_domain: "於您的網域上。",
  dns_change_time: "（DNS變更最多需24小時）",
  add_domain: "新增網域",
  add_personal_domain: "新增個人網域",
  min_characters: "最小輸入字元數",
  domain_format:
    "網站網域需為 https://terminalads.com 或 terminalads.com 格式。",
  invalid_domain: "輸入的網域無效！",
  domain_added_successfully: "您的網域已成功新增",
  invalid_dns_settings: "DNS設定無效！",
  deleted_successfully: "已成功刪除",
  location: "位置",
  save_contact: "儲存聯絡人",
  search: "搜尋",
  data_fetch_error: "擷取資料時發生錯誤！",
  error: "錯誤",
  view_qr: "檢視QR碼",
  qr_design: "QR設計",
  register: "註冊",
  terminal_ads: "終端廣告",
  manage_40_advertising_methods: "同時管理40種廣告方式！",
  ms_khansari: "康薩里女士",
  support: "支援",
  comprehensive_advertising_system: "唯一全面檢測與管理線上廣告的系統",
  terminal_ads_description:
    "終端廣告系統以持續且有效的客戶與使用者溝通為榮，旨在理解其需求並提供最佳解決方案。我們最大的資本是忠誠的客戶與使用者，其次是擁有新穎創意與現代技術支援公司的專家團隊。",
  please_enter_qr_address_correctly: "請正確輸入QR碼網址！",
  server_error: "伺服器錯誤！",
  please_enter_your_address: "請輸入您的地址",
  please_enter_instagram_address: "請輸入您的Instagram地址",
  please_enter_whatsapp_address: "請輸入您的WhatsApp地址",
  enter_information: "輸入資訊",
  dynamic_qr: "動態QR碼",
  coming_soon: "即將推出",
  qr_name: "QR碼名稱",
  for_default_address_leave_empty: "！使用預設網址請留空",
  default_address: "預設網址",
  sms: "簡訊",
  enter_number_without_zero: "輸入號碼不含0。",
  number: "號碼",
  country_code: "國碼：",
  sms_text: "簡訊內容",
  complete_sms_fields_correctly: "請正確填寫簡訊欄位！",
  qr_code_created_successfully: "您的二維碼已成功創建。",
  chat: "聊天",
  call: "打電話",
  please_enter_username: "請輸入使用者名稱。",
  username: "使用者名稱",
  sample_menu: "範例選單",
  online_menu_name: "您的線上選單名稱",
  online_menu_name_short: "線上選單",
  enter_menu_information: "輸入選單資訊",
  select_sample_menu: "選擇範例選單",
  select_ready_menu: "選擇現成選單",
  online_sales: "線上銷售",
  sales_settings: "銷售設定",
  photo_gallery: "圖片庫",
  fast_food1: "速食1",
  fast_food2: "速食2",
  products: "產品",
  pizzas: "披薩",
  pizza_rust_beef: "烤牛肉披薩",
  italian_pizza_with_beef: "義大利牛肉披薩",
  italian_pizza_dough_30cm: "義大利披薩麵團 30公分",
  "100g_shredded_beef": "100克牛肉絲",
  mushroom_bell_pepper: "蘑菇，甜椒",
  black_olives: "黑橄欖",
  pizza_chicken_mushroom: "雞肉蘑菇披薩",
  classic_40cm: "經典 40公分",
  fresh_tomato_sauce: "新鮮番茄醬，起司，雞肉片，蘑菇，山百里香",
  pizza_meat_mushroom: "肉蘑菇披薩",
  meat_pizza_with_mushroom: "絞肉蘑菇披薩",
  pizza_vegetables: "蔬菜披薩",
  american_vegetable_pizza: "美式蔬菜披薩",
  american_pizza_dough:
    "美式披薩麵團，玉米，蘑菇，橄欖，番茄，洋蔥，甜椒，起司",
  special_pizza: "特色披薩",
  american_special_pizza: "美式特色披薩",
  pizza_bolognese: "波隆那披薩",
  one_person_23cm: "(1人) 披薩麵團 23公分",
  pepperoni_pizza: "義大利辣香腸披薩",
  one_person_23cm_dough: "(1人) 披薩麵團 23公分",
  bacon_pizza: "培根披薩",
  one_person_23cm_explosion: "(1人) 披薩麵團 23公分",
  mixed_pizza: "雜錦披薩",
  one_person_23cm_mixed: "(1人) 披薩麵團 23公分",
  american_steak_pizza: "美式牛排披薩",
  one_person_23cm_steak: "(1人) 23公分",
  burgers: "漢堡",
  cheese_burger: "起司漢堡",
  with_french_fries: "配薯條",
  "2_beef_burgers_150g": "2個150克牛肉漢堡",
  special_sauce_gouda_cheese: "特色醬，豪達起司",
  pickles_lettuce_tomato: "醃黃瓜，生菜，番茄",
  special_sauce: "特色醬",
  burger: "漢堡",
  pure_meat_with_special_sauce: "特色醬純肉",
  chicken_burger: "雞肉漢堡",
  grilled_chicken_burger_with_cheese: "烤雞起司漢堡",
  spicy_burger: "辣味漢堡",
  beef_with_spicy_sauce: "辣醬牛肉",
  double_burger: "雙層漢堡",
  "150g_beef": "150克牛肉",
  royal_burger: "皇家漢堡",
  "150g_beef_emoji": "150克牛肉",
  mushroom_burger: "蘑菇漢堡",
  "150g_beef_mushroom": "150克牛肉蘑菇",
  mushroom_burger_grilled: "烤蘑菇漢堡",
  "100_percent_grilled_beef": "100%烤牛肉",
  fried_burger: "炸漢堡",
  "100_percent_grilled_fried": "100%烤炸牛肉",
  fried: "炸",
  fried_chicken: "炸雞",
  "3_piece_fried_chicken": "3塊炸雞",
  "3_fried_chicken_pieces": "3塊炸雞",
  "120_150g_french_fries": "120-150克薯條",
  enter_product_information: "輸入產品資訊",
  product_name: "您的產品名稱",
  product_name_short: "產品名稱",
  complete_features_from_image: "根據產品圖片填寫特性",
  skip_step: "跳過此步",
  product_and_information: "產品與資訊",
  product_introduction: "產品介紹",
  shiva_waves: "濕婆之波",
  think_best: "想得更好...",
  iran_zanjan_abhar: "伊朗，贊詹，阿巴爾，謝里夫工業區，63/20千伏變電站旁",
  video_gallery_description: "觀看我們的影片。",
  gallery: "圖庫",
  welcome: "歡迎",
  invalid_address: "輸入的地址無效！",
  product_created_successfully: "您的產品已成功創建。",
  qr_visit_card_edited_successfully: "您的名片已成功編輯。",
  change_header_color: "更改標題顏色",
  change_body_color: "更改正文顏色",
  change_button_colors: "更改按鈕顏色",
  change_text_colors: "更改文字顏色",
  gradient_colors: "漸層顏色",
  color_direction: "顏色方向",
  first_color: "第一種顏色",
  second_color: "第二種顏色",
  color: "顏色",
  text_color: "文字顏色",
  from_top: "從上",
  from_bottom: "從下",
  from_left_to_right: "從左到右",
  from_right_to_left: "從右到左",
  from_top_to_left: "從左上",
  from_top_to_right: "從右上",
  from_bottom_to_left: "從左下",
  from_bottom_to_right: "從右下",
  sharing: "分享",
  business_shop: "商業/商店",
  corporate_organizational: "公司/組織",
  customer_contact: "客戶聯繫",
  information: "資訊",
  miscellaneous: "其他",
  link: "連結",
  margin: "邊距",
  width: "寬度",
  height: "高度",
  background_color: "背景顏色",
  gradient_color: "漸層顏色",
  linear: "線性",
  radial: "徑向",
  color_rotation: "顏色旋轉",
  background_color_label: "背景顏色",
  dots_color: "點顏色",
  dots_color_label: "點顏色",
  eye_colors: "眼睛顏色",
  separate_colors_for_each_eye: "每隻眼睛單獨顏色",
  current_mode: "當前模式：",
  separate_colors: "單獨顏色",
  same_color: "相同顏色",
  all_eyes_color: "所有眼睛顏色",
  top_right_eye: "右上眼",
  top_left_eye: "左上眼",
  bottom_left_eye: "左下眼",
  upload_logo: "上傳標誌",
  hide_background_dots: "隱藏標誌後點",
  logo_size: "標誌大小",
  logo_margin: "標誌邊距",
  qr_accuracy: "二維碼精度",
  mode: "模式",
  error_correction_level: "錯誤更正等級",
  numeric: "數字",
  alphanumeric: "字母數字",
  byte: "位元組",
  apply_changes: "套用變更",
  please_click_apply_changes: "選擇修改後點擊「套用變更」。",
  created_qr_codes: "已創建的二維碼",
  square_ratio: "1:1（正方形）",
  image_upload_error: "圖片上傳錯誤！",
  visit_card_name_label: "名片名稱",
  sms_membership_message: "客戶俱樂部會員簡訊",
  admin_menu: "管理員選單",
  user_menu: "使用者選單",
  guide_tooltip: "指南",
  close: "關閉",
  browser_video_support_error: "您的瀏覽器不支援任何影片格式。",
  video_loading_error: "影片載入錯誤（可能存取受限）。",
  click_more_for_videos: "點擊「更多」查看更多影片。",
  more_info: "更多資訊",
  more: "更多",
  add_user_guide: "添加使用者指南",
  edit_user_guide: "編輯使用者指南",
  display_info: "顯示資訊",
  element: "元素",
  disable_attach: "停用頁面貼合",
  view: "檢視",
  guide: "指南",
  details: "詳情",
  guide_images: "指南圖片",
  guide_videos: "指南影片",
  faq: "常見問題",
  data_preload_error: "資料預載入錯誤：",
  guide_not_found: "未找到指南。請先創建指南。",
  delete_guide_question: "刪除指南？",
  delete_guide_error: "刪除指南錯誤！",
  unknown_file_type: "未知檔案類型：",
  content_type_error: "取得內容類型錯誤：",
  video: "影片",
  image: "圖片",
  guide_data_error: "取得指南資料錯誤：",
  add_iranian_stores: "添加伊朗商店",
  add_foreign_stores: "添加外國商店",
  bazaar: "巴扎",
  myket: "麥凱特",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "三星商店",
  xiaomi_store: "小米商店",
  vivo_store: "Vivo商店",
  amazon_store: "亞馬遜商店",
  bazaar_app: "巴扎應用",
  bazaar_link_placeholder: "輸入巴扎應用連結",
  bazaar_link_hint:
    "輸入有效的巴扎連結（例如：https://cafebazaar.ir/app/com.abankefarda）",
  myket_app: "麥凱特應用",
  myket_link_placeholder: "輸入麥凱特應用連結",
  myket_link_hint:
    "輸入有效的麥凱特連結（例如：myket://details?id=com.example）",
  app_store_app: "App Store應用",
  app_store_link_placeholder: "輸入App Store應用連結",
  app_store_link_hint:
    "輸入有效的App Store連結（例如：https://apps.apple.com/us/app/appname/id123456789）",
  google_play_app: "Google Play應用",
  google_play_link_placeholder: "輸入Google Play應用連結",
  google_play_link_hint:
    "輸入有效的Google Play連結（例如：https://play.google.com/store/apps/details?id=com.example）",
  samsung_store_app: "三星商店應用",
  samsung_store_link_placeholder: "輸入三星商店應用連結",
  samsung_store_link_hint:
    "輸入有效的三星商店連結（例如：https://galaxy.store/appname）",
  xiaomi_store_app: "小米商店應用",
  xiaomi_store_link_placeholder: "輸入小米商店應用連結",
  xiaomi_store_link_hint: "輸入有效的小米商店連結",
  vivo_app_store: "Vivo應用商店",
  vivo_app_store_app: "Vivo應用商店應用",
  vivo_app_store_link_placeholder: "輸入Vivo應用商店連結",
  vivo_app_store_link_hint: "輸入有效的Vivo應用商店連結",
  amazon_store_app: "亞馬遜商店應用",
  amazon_store_link_placeholder: "輸入亞馬遜商店應用連結",
  amazon_store_link_hint: "輸入有效的亞馬遜商店連結",
  iranian_store: "伊朗商店",
  foreign_store: "外國商店",
  personal_store: "個人商店",
  image_logo: "圖片/標誌",
  image_gallery: "圖片庫",
  header_image: "標題圖片",
  template_background_image: "模板背景圖片",
  background_image: "背景圖片",
  background_image_alt: "背景圖片",
  logo_upload: "上傳標誌",
  welcome_image: "歡迎圖片",
  welcome_image_logo_upload: "上傳歡迎圖片/標誌",
  loading_animation: "載入動畫",
  preview_welcome_page: "預覽歡迎頁面",
  max_background_size: "最大背景圖片大小：2MB。",
  max_logo_size: "最大標誌大小：2MB。",
  scale_from_center: "從中心縮放",
  slide_from_left: "從左滑動",
  slide_from_top: "從上滑動",
  fade: "淡入淡出",
  select_music_card: "選擇音樂卡",
  show_audio: "顯示音訊",
  hide_audio: "隱藏音訊",
  add_voice: "添加語音",
  max_files_limit: "您不能選擇超過 {count} 個檔案！",
  files_not_allowed: "不允許檔案！",
  voice_gallery: "語音庫",
  edit_voice: "編輯語音",
  list: "列表",
  file_name: "檔案名稱",
  title: "標題",
  description: "描述",
  selectdate: "選擇日期",
  background: "背景",
  text: "文字",
  delete_audio_confirm: "您確定要從您的庫中刪除音訊檔案嗎？",
  add_voice_gallery: "添加語音庫",
  gallery_number: "庫",
  delete_confirm: "您確定要刪除嗎？",
  confirm: "確認",
  voice_gallery_title_hint: "輸入您的語音庫標題。",
  voice_gallery_title: "標題",
  voice_gallery_subtitle_hint: "輸入您的語音庫副標題。",
  voice_gallery_subtitle: "語音庫副標題",
  voice_gallery_subtitle_alt: "副標題",
  website_address_hint: "輸入您的網站地址。",
  website_address: "網站地址",
  about_voice_gallery: "關於庫",
  about_voice_gallery_alt: "關於庫",
  button_name_hint: "輸入按鈕名稱。",
  button_name: "按鈕名稱",
  domain_format_hint: "域名必須是 https://terminalads.com 或 terminalads.com。",
  about_us_alt: "關於我們",
  add_default_form: "添加預設表單",
  delete_all: "刪除全部",
  validation_active: "驗證：啟用",
  validation_inactive: "驗證：停用",
  validation: "驗證",
  clear_form: "清除表單",
  status: "狀態",
  active: "啟用",
  inactive: "停用",
  optional: "可選",
  required: "必填",
  question_title: "標題",
  question_title_hint: "輸入問題標題",
  options_hint: "寫下選項並按回車添加",
  options: "選項",
  add_suggested_form: "添加建議表單",
  save_changes: "儲存變更",
  add_request_field: "添加請求欄位",
  select_form_type: "選擇表單類型",
  select_form_type_placeholder: "選擇表單類型",
  dropdown: "下拉選單",
  text_field: "文字欄位",
  number_field: "數字欄位",
  textarea_field: "文字區域",
  date_field: "日期欄位",
  field_name_required: "請勿空白欄位名稱",
  field_name: "欄位名稱",
  add_field_name: "添加欄位名稱",
  field_label: "欄位標籤",
  add_field_label: "添加欄位標籤",
  advanced_settings: "進階設定",
  select_input_pattern: "選擇輸入模式",
  select_input_pattern_placeholder: "選擇輸入模式",
  max_characters: "最大字元數",
  min_input_error: "最小輸入必須為0",
  name_field: "姓名",
  field_type: "欄位類型",
  persian_limit: "波斯語限制",
  family_name: "姓氏",
  mobile_number: "手機號碼",
  number_limit: "數字限制",
  national_code: "國碼",
  meli_code: "國碼",
  email: "電子郵件",
  email_limit: "電子郵件限制",
  dropdown_field: "下拉欄位",
  english_limit: "英語限制",
  mix_per_eng_limit: "波斯語與英語混合限制",
  site_limit: "網站限制",
  form_added_successfully: "新表單已成功添加",
  form_updated_successfully: "表單已成功更新",
  delete_item_confirm: "您確定要刪除此項嗎？",
  default_form_added_successfully: "預設表單已成功添加",
  resources_upload_error: "資源上傳錯誤",
  update_value_if_duplicate: "重複時更新值",
  first_tab: "第一個標籤頁",
  display_count: "顯示數量",
  buy_renew_qr_instruction: "要購買/續訂二維碼，請點擊到期日期按鈕。",
  days_until_expiry: "到期剩餘天數",
  expired: "已過期",
  no_qr_to_display: "沒有二維碼可顯示！",
  second_tab: "第二個標籤頁",
  total_qr_codes: "總二維碼數",
  select_all: "全選",
  selected_qr_codes_count: "已選二維碼數",
  qr_codes_count: "二維碼數量",
  group_renewal_instruction: "要批量續訂，請選擇所需的二維碼。",
  no_qr_found_with_filters: "未找到符合這些篩選條件的二維碼！",
  qr_codes_count_label: "二維碼數量：",
  renew_qr: "續訂二維碼",
  days: "天",
  buy_now: "立即購買！",
  buy_now_label: "購買",
  add_discount_code: "添加折扣碼",
  use_discount_code: "使用折扣碼",
  discount_code: "折扣碼",
  submit: "提交",
  my_qr_list: "我的二維碼列表",
  group_renewal: "批量續訂",
  row: "行",
  type: "類型",
  clicks: "點擊",
  created_at_diff: "創建時間",
  updated_at_diff: "更新時間",
  table_view: "表格檢視",
  normal_view: "普通檢視",
  no_qr_or_id_selected: "未選擇二維碼或ID！",
  qr_updated_successfully: "二維碼已成功更新。",
  qr_update_error: "更新二維碼錯誤！",
  no_qr_selected: "未選擇二維碼！",
  no_qr_code_selected: "未選擇二維碼！",
  success: "成功",
  qrs_upgraded_successfully: "您的二維碼已成功升級。",
  qr_renewal_error: "二維碼續訂請求問題！",
  changed_successfully: "已成功變更。",
  error_occurred: "發生錯誤！",
  no_tariff_exists: "此期間無資費！",
  qr_upgraded_successfully: "您的二維碼已成功升級。",
  check_account_balance: "請檢查帳戶餘額並稍後重試。",
  group_renewal_price_error: "取得批量續訂價格錯誤！",
  qr_count_error: "取得二維碼數量錯誤！",
  no_qr_for_renewal: "沒有二維碼可續訂！",
  table_pagination: "表格分頁",
  virtual_scroll_display: "虛擬滾動顯示",
  popups_shared_components: "彈出視窗和共享組件",
  edit_qr_address: "編輯二維碼地址",
  please_enter_correct_address: "請輸入正確地址",
  successfully_edited: "已成功編輯。",
  error_editing_qr_address: "編輯二維碼地址錯誤！",
  go_to_page: "轉到頁面",
  page_from_to: "第 {current} 頁 / 共 {last} 頁",
  display: "顯示",
  to: "到",
  from: "從",
  show: "顯示",
  page_status: "第 {current} 頁 / 共 {total} 頁",
  until: "直到",
  successfully_completed: "已成功完成",
  problem_occurred: "出現問題",
  download_failed: "下載失敗",
  audio_file_default: "音訊檔案",
  memory_release: "釋放記憶體",
  seek_music_comment: "例如，這首音樂或尋找的東西",
  all: "全部",
  create_podcast: "創建播客",
  add_link: "添加連結",
  upload_file: "上傳檔案",
  file_list: "檔案列表",
  count: "數量",
  select_category: "選擇類別",
  after_typing_enter: "輸入後按回車。",
  no_image_available: "圖片不可用",
  no_image_found: "未找到圖片！",
  for_adding_file_use_upload_center: "要添加檔案，請使用上傳區域或上傳中心",
  ai_story_creation_description: "輸入您的故事，AI將為您創建",
  create_new_podcast: "創建新播客",
  show_audio_file: "顯示音訊檔案",
  cancel: "取消",
  no_audio_in_category: "此類別中無音訊",
  health_apple: "健康蘋果",
  standard: "標準",
  arshia_badge: "阿爾希亞徽章",
  home_appliances_association: "家電協會",
  energy_label: "能源標籤",
  select_gold_purity_first: "要取得價格，請先選擇黃金純度",
  gold_price_service: "黃金價格服務",
  rahvard: "拉赫瓦德",
  to_change_gold_service_go_to_assets: "要更改黃金價格服務，請轉到資產",
  gold: "黃金",
  purity: "純度",
  rial: "里亞爾",
  final_product_price: "最終產品價格",
  show_images_right_side: "右側顯示圖片",
  show_as_slider: "以滑塊顯示",
  show_as_grid: "以網格顯示",
  show_as_second_mode: "以第二模式顯示",
  gallery_name: "庫名稱",
  change_gallery_name: "更改庫名稱",
  add_photo: "添加照片",
  select_photo: "選擇照片",
  show_image: "顯示圖片",
  selected_photo: "已選照片",
  to_use_ready_images_search_category_or_product:
    "要使用現成圖片，請在上方搜尋類別或產品。",
  max_file_size_2mb: "最大檔案大小：2MB。",
  drag_and_drop_to_upload_or: "拖放上傳或",
  here: "此處",
  click: "點擊",
  to_use_external_image_link_fill_fields: "要使用外部圖片連結，請填寫以下欄位",
  image_url_hint: "所需圖片URL（連結）。",
  image_url: "圖片連結",
  add_new_gallery: "添加新庫",
  create_image: "創建圖片",
  ready_images: "現成圖片",
  edit_image: "編輯圖片",
  enter_valid_link: "輸入有效連結。",
  max_background_image_size_2mb: "最大背景圖片大小：2MB。",
  uploaded_successfully: "已成功上傳。",
  banner: "橫幅",
  question: "問題",
  selected_question: "已選問題",
  answer: "答案",
  add_question: "添加問題",
  selected_blog: "已選部落格",
  icon: "圖示",
  select_icon: "選擇圖示",
  add_blog: "添加部落格",
  post: "貼文",
  selected_services: "已選服務",
  add_new_post: "添加新貼文",
  add_new_services: "添加新服務",
  add_new_service: "添加新服務",
  domain_must_be_https_or_http:
    "域名必須是 https://terminalads.com 或 terminalads.com。",
  id: "ID",
  images: "圖片",
  tags: "標籤",
  print_type: "列印類型",
  user: "使用者",
  user_shipping_info: "使用者配送資訊",
  qr_short_link: "二維碼短連結",
  delivery_method: "配送方式",
  delivery_at_company: "公司配送",
  delivery_by_post: "郵寄配送",
  post_cost_and_tax_warning: "註冊時將從您的錢包扣除郵費和10%稅。",
  shipping_info: "配送資訊",
  continue_shopping: "繼續購物",
  complete_shopping: "完成購買",
  select_free_nfc_card: "選擇免費NFC卡",
  order_custom_nfc_card: "訂購自訂NFC卡",
  buy_qr_equipment: "購買二維碼設備",
  vertical: "垂直",
  horizontal: "水平",
  card_type: "卡類型",
  tag: "標籤",
  select: "選擇",
  order_card: "訂購卡",
  available: "可用",
  unavailable: "不可用",
  for_initial_loading: "用於初始載入",
  already_have_free_nfc_message:
    "您已為此二維碼獲得免費NFC。要更改，請購買自訂卡。",
  nfc_in_delivery_process_message:
    "您已註冊免費NFC，正在配送中。要更改，請購買自訂卡。",
  free_nfc_card_warning_message:
    "尊敬的使用者：免費NFC卡為預印，您的二維碼會更改。如已使用，請購買自訂卡。",
  select_card: "選擇卡",
  free_card_selection_conditions: "免費卡選擇條件",
  confirm_and_select: "確認並選擇",
  registered_successfully: "已成功註冊。",
  error_registering_nfc_order: "註冊NFC卡訂單錯誤！",
  nfc_physical_card_orders: "實體NFC卡訂單",
  buy_equipment: "購買設備",
  select_quantity: "選擇數量",
  ready_samples: "現成樣本",
  upload_custom_design: "上傳自訂設計",
  select_ready_card_image: "選擇現成卡圖片",
  select_card_front_image: "選擇卡正面圖片",
  select_card_back_image: "選擇卡背面圖片",
  nfc_card_image: "NFC卡圖片",
  add_quantity: "添加數量",
  total_price: "總價",
  price_with_discount: "折扣價",
  shipping_cost: "運費",
  your_profit_from_purchase: "您從購買中獲利",
  discount: "折扣",
  ten_percent_tax_will_be_added: "將向最終金額添加10%稅。",
  payable_amount: "應付金額",
  continue: "繼續",
  Confirm_code: "確認碼",
  form_success_message: "您的表單已成功提交",
  refill_form_message: "請重新填寫表單",
  Enter_the_sent_code: "輸入發送給您的代碼",
  SUBMIT_FORM: "提交表單",
  enter_phone_number: "輸入您的手機號碼",
  order_registered_successfully: "您的訂單已成功註冊。",
  smart_creation: "智能創建",
  automatic_creation: "自動創建",
  business_name: "商業名稱",
  example_household_goods: "範例：家居用品",
  organization_name: "組織名稱",
  example_tech_company: "範例：先進技術公司",
  minimum_two_characters_required: "至少需要兩個字元！",
  maximum_100_characters_allowed: "最多100個字元",
  latin_name_qr_address: "拉丁名稱（二維碼地址）",
  example_advanced_tech: "範例：advanced-tech",
  only_english_numbers_dash_allowed: "僅允許英文、數字和連字符",
  maximum_50_characters_allowed: "最多50個字元",
  latin_name_goes_after_domain: "拉丁名稱在域名後",
  select_logo_and_store_product_image: "選擇標誌和商店/產品圖片",
  select_logo: "選擇標誌",
  file_size_must_be_less_than_2mb: "檔案大小必須小於2MB",
  for_buying_renewing_qr_click_expiry_button:
    "要購買/續訂二維碼，請點擊到期日期按鈕。",
  for_group_renewal_select_desired_qr_codes: "要批量續訂，請選擇所需的二維碼。",
  no_qr_found_with_these_filters: "未找到符合這些篩選條件的二維碼！",
  i_buy: "我購買",
  visits: "訪問",
  creation_time: "創建時間",
  edit_time: "編輯時間",
  enter_business_card_name_correctly: "請正確輸入名片名稱！",
  are_you_sure_delete_qr: "您確定要刪除二維碼嗎？",
  qr_deleted_successfully: "二維碼已成功刪除。",
  are_you_sure_deactivate_qr: "您確定要停用二維碼嗎？",
  are_you_sure_activate_qr: "您確定要啟用二維碼嗎？",
  deactivated: "已停用",
  qr_successfully: "二維碼成功",
  successfully: "成功",
  user_transferred_successfully: "使用者已成功轉移",
  problem_occurred_in_transfer: "轉移中出現問題！",
  error_in_user_transfer: "使用者轉移錯誤！",
  qr_business_card_edited_successfully: "您的名片已成功編輯。",
  group_qr_renewal: "批量二維碼續訂",
  select_desired_duration: "選擇所需時長",
  total_count: "總數",
  final_amount: "最終金額",
  ten_percent_vat_will_be_added: "將向上述金額添加10%增值稅。",
  pay_and_upgrade: "支付並升級",
  no_tariff_for_this_period: "此期間無資費！",
  selected: "已選",
  total_amount: "總金額",
  final_amount_with_discount: "折扣後最終金額",
  add_qr: "添加二維碼",
  actions: "操作",
  filter_type: "類型篩選",
  start_from: "從...開始",
  search_in_id: "在ID中搜尋",
  filter_user: "使用者篩選",
  clear_filters: "清除篩選",
  send_sms: "發送簡訊",
  selected_pattern: "已選模式",
  send: "發送",
  bulk_download: "批量下載",
  one_month_renewal: "一個月續訂",
  three_month_renewal: "三個月續訂",
  six_month_renewal: "六個月續訂",
  one_year_renewal: "一年續訂",
  no_item_selected: "未選擇項目！",
  error_loading_card_info: "載入卡資訊錯誤！",
  send_registered_successfully: "發送已成功註冊",
  error_getting_prices: "取得價格錯誤！",
  payment_error: "支付錯誤！",
  business_card: "名片",
  product_label: "產品標籤",
  restaurant_menu: "餐廳選單",
  event_ticket: "活動門票",
  brochure: "宣傳冊",
  flyer: "傳單",
  poster: "海報",
  catalog: "目錄",
  newsletter: "通訊",
  organization_name_hint: "輸入您的組織名稱。",
  organization_name_label: "組織名稱",
  sub_organization_hint: "輸入子組織名稱。",
  sub_organization_label: "子組織描述",
  user_name_hint: "輸入您的姓名。",
  user_name_label: "姓名",
  work_field_hint: "輸入您的職位。",
  work_field_label: "職位",
  mobile_number_hint: "輸入您的號碼。",
  mobile_number_label: "手機號碼",
  phone_number_hint: "輸入電話號碼。",
  phone_number_label: "電話號碼",
  email_hint: "輸入您的電子郵件。",
  email_label: "電子郵件",
  fax_hint: "輸入公司傳真。",
  fax_label: "公司傳真",
  website_hint: "輸入公司網站。",
  website_label: "公司網站",
  postal_code_hint: "輸入郵政編碼。",
  postal_code_label: "郵政編碼",
  copyright_hint: "輸入頁腳版權文字。",
  copyright_label: "版權文字",
  address_hint: "輸入您的地址。",
  address_label: "地址",
  add_more_info: "添加更多您想要的資訊：",
  edit_location: "編輯",
  add_location: "添加",
  delete_location: "刪除位置",
  about_us_label: "關於我們",
  search_address: "搜尋地址：",
  northern_coordinates: "北緯座標",
  eastern_coordinates: "東經座標",
  select_address_on_map: "在地圖上選擇地址",
  location_not_found: "未找到位置。",
  text_label: "文字",
  number_label: "數字",
  website_address_label: "網站地址",
  location_label: "位置",
  mobile_viewer_title: "行動檢視器",
  visit_theme_two_title: "名片主題2",
  visit_theme_flipped_title: "翻轉名片主題",
  flip_card: "翻轉卡片",
  flip_card_description: "要檢視更多資訊，請翻轉卡片",
  share_contacts: "分享聯絡人",
  close_share: "關閉分享",
  card_front: "卡片正面",
  card_back: "卡片背面",
  flip_to_back: "翻到背面",
  flip_to_front: "翻到正面",
  swipe_to_flip: "滑動翻轉",
  swipe_left: "向左滑動",
  swipe_right: "向右滑動",
  expand_card: "展開卡片",
  contract_card: "收起卡片",
  view_details: "檢視詳情",
  hide_details: "隱藏詳情",
  social_media_share: "社交媒體分享",
  contact_actions: "聯絡操作",
  card_actions: "卡片操作",
  floating_menu: "浮動選單",
  close_menu: "關閉選單",
  open_menu: "打開選單",
  choice_gallery: "已選庫",
  choice_video: "選擇影片",
  url_video: "影片連結",
  selected_video: "已選影片",
  add_video: "添加影片",
  edit_video: "編輯影片",
  linl_video: "發佈連結",
  upload_video: "上傳影片",
  rule_link: "域名必須是 https://terminalads.com 或 terminalads.com。",
  fax_hint: "輸入公司傳真。",
  fax_label: "公司傳真",
  website_hint: "輸入公司網站。",
  website_label: "公司網站",
  postal_code_hint: "輸入郵政編碼。",
  postal_code_label: "郵政編碼",
  add_more_info: "添加更多您想要的資訊：",
  address_hint: "輸入您的地址。",
  address_label: "地址",
  edit_location: "編輯",
  add_location: "添加",
  delete_location: "刪除位置",
  location_label: "位置",
  about_company_label: "關於公司",
  select_address_on_map: "在地圖上選擇地址",
  search_address: "搜尋地址：",
  rule_link: "域名必須是 https://terminalads.com 或 terminalads.com。",
  link_label: "連結地址",
  label_label: "標籤",
  field_value_label: "欄位值",
  add_new_field: "添加新欄位",
  tehran_address: "德黑蘭，沙里亞蒂街，賽義德·漢丹橋後，漢丹巷，6號",
  welcome_message_hint: "啟用後，客戶加入您的俱樂部時將發送歡迎訊息。",
  change_pattern_campaign: "更改模板/活動",
  selected_message: "已選訊息：",
  required_inputs: "必填欄位：",
  selected_campaign_or_pattern: "已選活動/模板：",
  campaign: "活動",
  pattern: "模板",
  id: "ID",
  auto_csv_download_label: "自動儲存",
  auto_csv_download_hint: "卡片打開時您的資訊將自動下載到客戶手機。",
  show_cclub_onload_label: "會員提議",
  show_cclub_onload_hint: "將打開加入客戶俱樂部的視窗。",
  forced_submission_hint: "顯示會員表單時，客戶必須註冊其號碼。",
  forced_submission_forced: "強制會員",
  forced_submission_optional: "可選會員",
  has_manifest_icons_label: "網頁應用設定",
  has_assistant_label: "助手標籤",
  select_assistant: "選擇助手",
  assistant_ai: "人工智慧助手",
  has_manifest_icons_hint: "安裝網頁應用到手機或電腦時，將顯示標誌和圖片。",
  logo_144px: "標誌 144像素",
  logo_48px: "標誌 48像素",
  photo_wide: "寬幅照片",
  photo: "照片",
  iranian_social_networks: "伊朗社交網絡",
  foreign_social_networks: "外國社交網絡",
  advertising_sites: "廣告網站",
  other_links: "其他連結",
  custom_text: "自訂文字",
  custom_text_placeholder: "輸入您的自訂文字。",
  aparat: "阿帕拉特",
  aparat_hint: "輸入您的阿帕拉特頻道名稱",
  eitaa: "艾塔",
  eitaa_hint: "輸入您的使用者名稱",
  soroush: "蘇魯什",
  soroush_hint: "輸入您的使用者名稱",
  bale: "巴勒",
  bale_hint: "輸入您的使用者名稱",
  rubika: "魯比卡",
  rubika_hint: "輸入頻道/群組連結",
  gap: "加普",
  gap_hint: "輸入您的使用者名稱",
  linkedin: "LinkedIn 個人頁面",
  linkedin_hint: "輸入您的使用者名稱",
  linkedin_company: "LinkedIn 公司頁面",
  linkedin_company_hint: "輸入您的公司頁面名稱",
  pinterest: "拼趣",
  pinterest_hint: "輸入您的使用者名稱",
  dribbble: "德里布爾",
  dribbble_hint: "輸入您的使用者名稱",
  facebook: "臉書",
  facebook_hint: "輸入您的使用者名稱",
  github: "GitHub",
  github_hint: "輸入您的使用者名稱",
  threads: "線程",
  threads_hint: "輸入您的使用者名稱",
  tiktok: "抖音",
  tiktok_hint: "輸入您的使用者名稱",
  twitter: "推特",
  twitter_hint: "輸入您的使用者名稱",
  skype: "Skype",
  skype_hint: "輸入您的使用者名稱",
  youtube: "優兔",
  youtube_hint: "不帶@輸入您的使用者名稱",
  wechat: "微信",
  wechat_hint: "輸入您的使用者名稱",
  viber: "Viber",
  viber_hint: "輸入您的使用者名稱",
  divar: "迪瓦爾",
  divar_hint: "輸入廣告/看板/商店連結",
  sheypoor: "謝普爾",
  sheypoor_hint: "輸入廣告/看板/商店連結",
  social_network: "社交網絡",
  photo_logo_tab: "圖片/標誌",
  gallery_image_tab: "圖片庫",
  template_image: "模板圖片",
  background_image: "背景圖片",
  upload_logo: "上傳標誌",
  welcome_image_upload: "上傳歡迎圖片/標誌",
  welcome_photo: "歡迎照片",
  loading_animation: "載入動畫",
  preview_welcome_page: "預覽歡迎頁面",
  default_template_image: "預設模板背景圖片",
  default_background_image: "預設背景圖片",
  default_logo: "預設標誌",
  default_welcome: "預設歡迎",
  default_gallery: "預設庫",
  animation_scale: "從中心縮放",
  animation_slide_x: "從左滑動",
  animation_slide_y: "從上滑動",
  animation_fade: "淡入淡出",
  image_size_error: "最大背景圖片大小：2MB。",
  logo_size_error: "最大標誌大小：2MB。",
  categories: {
    bankcard: '銀行卡',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "文字",
    multi_card: "多功能卡",
    product_introduction_pro: "產品介紹 Pro",
    electronic_business_card_pro: "專業電子名片",
    link_pro:"Link Pro",
    generated_images: "生成的圖片",
    electronic_business_card: "電子名片",
    social_media: "社交媒體",
    photo_gallery: "圖片庫",
    video_gallery: "影片庫",
    link: "連結",
    audio_gallery: "音訊庫",
    audio_gallery_pro: "音訊庫（專業版）",
    feedback: "反饋",
    consultation_form: "諮詢表單",
    application: "應用",
    pdf_gallery: "PDF庫",
    schedule_table: "時間表",
    personal_company_website: "個人/公司網站",
    online_store: "線上商店",
    online_menu: "線上選單",
    appointment_booking: "預約",
    commercial_admin_website: "商業/管理網站",
    online_insurance_sales: "線上保險銷售",
    discount_code: "折扣碼",
    product_introduction: "產品介紹",
    product_label: "產品標籤",
    gold_label: "黃金標籤",
    franchise: "加盟（商業頁面）",
    marketplace: "市場（商業頁面）",
    recruitment_form: "招聘表單",
    organizational_form: "組織表單",
    employee_card: "員工卡",
    book_magazine: "書籍/雜誌",
    catalog_brochure: "目錄/宣傳冊",
    catalog: "目錄",
    faq: "常見問題",
    feedback_survey: "反饋/調查",
    consultation_request: "諮詢請求",
    customer_club: "客戶俱樂部",
    invitation_card: "邀請卡",
    countdown: "倒數計時",
    tombstone: "墓碑",
  },
  support_day60: "60天退款保證",
  "enter_visit_card_pro_info": "請輸入 Pro 名片名稱",
  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "編輯 QR 碼文字",
       SERVER_DOWN: "系統更新中",
    CREATE_MEMORIES_MODEL: "建立回憶相框模型",
    CREATE_CARD_VISIT_PRO_MODEL: "建立專業名片模型",
    CREATE_PRODUCT_PRO_MODEL: "建立專業產品介紹模型",
    CREATE_PRODUCT_LABEL_MODEL: "建立產品標籤模型",
    CREATE_PHOTO_GALLERY_MODEL: "建立圖片畫廊模型",
    CREATE_PDF_GALLERY_MODEL: "建立PDF畫廊模型",
    CREATE_SOCIAL_MEDIA_MODEL: "建立社交媒體模型",
    EDIT_CARD_VISIT_PRO_MODEL: "編輯專業名片模型",
    EDIT_PRODUCT_PRO_MODEL: "編輯專業產品介紹模型",
    EDIT_PRODUCT_LABEL_MODEL: "編輯產品標籤模型",
    EDIT_PHOTO_GALLERY_MODEL: "編輯圖片畫廊模型",
    EDIT_PDF_GALLERY_MODEL: "編輯PDF畫廊模型",
    EDIT_SOCIAL_MEDIA_MODEL: "編輯社交媒體模型",
    BOOK: "手冊 / 書籍",
    NFC_LIST: "NFC清單",
    API_KEY_MANAGER: "建立API金鑰",
    PRE_PURCHASE: "預購",
    PRE_PURCHASE_MODEL: "現成範本",
      "QR_NAME_EDIT_GIFT": "編輯禮物QR碼",
      "QR_GIFT": "禮物QR碼",
      "QR_NAME_EDIT_PRO": "編輯 Pro 連結 QR 碼",
      "QR_LINK_PRO": "QR Link Pro",
      DIGI: "Digikala價格監控",
      QR_PDF: "PDF圖庫",
      QR_NAME_EDIT_PDF: "編輯PDF圖庫",
      QR_MULTICART: "QR多卡",
      QR_MULTICART_EDIT: "編輯QR多卡",
      QR_NAME_PRODUCTPRO: "編輯產品專業版介紹",
      QR_PRODUCTPRO: "產品專業版介紹",
      QR_LUCK_WHEEL_Edit: "編輯幸運轉盤",
      QR_LUCK_WHEEL: "建立幸運轉盤 QR 碼",
      DASHBOARD: "儀表板",
      ADMIN_QR_DOMAINS: "域名監控",
      ADMIN_TOGETHER_TOKEN: "令牌監控",
      ADMIN_QR_SMS: "發送簡訊",
      MENU_PROFILE_INFO: "使用者資訊",
      MENU_PROFILE_SETTING: "個人資料設定",
      MENU_PROFILE_ORDERS: "訂單",
      MENU_PROFILE_ADDRESSES: "地址",
      QR_MONITORING: "二維碼監控",
      QR_LIST: "我的二維碼列表",
      QR_NAME_LIST: "參與管理",
      QR_GENERATE_MULTIPLE: "批量二維碼生成",
      QR_CARD_VISIT: "建立名片",
      HELP_INFO: "測試按鈕",
      QR_MENU: "商店選單",
      QR_APPOINTMENT: "預約",
      QR_INSURANCE: "建立線上保險",
      QR_BPAGE: "建立業務頁面",
      QR_CPAGE: "建立商業/行政綜合體網站",
      QR_BSHOP: "線上商店",
      QR_NAME_EDIT_BSHOP: "編輯線上商店",
      QR_LINK_EDIT: "編輯連結",
      QR_NAME_DESIGN: "編輯設計",
      QR_NAME_SETTING: "編輯設定",
      QR_NAME_EDIT: "編輯名片",
      QR_NAME_EDIT_BPAGE: "編輯業務頁面",
      QR_EDIT_CPAGE: "編輯商業/行政綜合體網站",
      QR_NAME_INSURANCE: "編輯線上保險",
      QR_NAME_EDIT_MENU: "編輯選單",
      QR_NAME_EDIT_APPLICATION: "提供應用程式",
      QR_NAME_EDIT_APPOINTMENT: "編輯預約",
      QR_NAME_EDIT_PHOTO: "編輯照片圖庫",
      QR_NAME_EDIT_VIDEO: "編輯影片圖庫",
      QR_NAME_EDIT_VOICE: "編輯音訊圖庫",
      QR_NAME_EDIT_FEEDBACK: "編輯回饋圖庫",
      QR_NAME_CONSULTATION_QR_EDIT: "編輯申請表單",
      QR_NAME_EDIT_VOICE_PRO: "編輯音訊圖庫（專業版）",
      QR_NAME_EDIT_SOCIAL: "編輯社交網路",
      QR_NAME_STATISTICS: "二維碼統計",
      QR_CATE: "選擇類別",
      QR_SHARE: "分享",
      QR_BUSINESS_SHOP: "企業/商店",
      QR_CO_ORGAN: "公司/組織",
      QR_CONTACT: "客戶聯繫",
      QR_NOTICES: "通知",
      QR_OTHERS: "其他",
      QR_STATICS: "靜態二維碼",
      QR_DYNAMICS: "動態二維碼",
      QR_D_BUSINESS: "動態企業二維碼",
      QR_D_ORGANS: "動態組織二維碼",
      QR_D_GOVERNMENT: "動態政府二維碼",
      QR_VIDEO: "影片圖庫",
      QR_APPLICATION: "提供應用程式",
      QR_VOICE: "音訊圖庫",
      QR_VOICE_PRO: "音訊圖庫（專業版）",
      QR_CONSULTATION_QR: "申請表單",
      QR_FEEDBACK: "回饋圖庫",
      QR_PHOTO: "照片圖庫",
      QR_CATALOG: "目錄 / 宣傳冊",
      QR_NAME_EDIT_CATALOG: "編輯目錄",
      QR_LOCATION: "建立位置二維碼",
      QR_SOCIAL_MEDIA: "建立社交媒體二維碼",
      QR_LINK: "建立連結",
      QR_TEXT: "建立文字",
      QR_MAIL: "建立電子郵件",
      QR_CALL: "通話",
      QR_SMS: "簡訊",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "網站",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "業務頁面",
      QR_DISCOUNT: "折扣頁面",
      QR_PRODUCT_SHOP: "產品介紹",
      QR_PRODUCT_LABEL: "產品標籤",
      QR_GOLD_LABEL: "黃金標籤",
      QR_PRODUCT_TEMPLATE: "產品",
      ADMIN_CATEGORY: "類別",
      QR_NFC_ORDERS: "等待確認的NFC卡",
      QR_NAME_PRODUCT: "編輯產品介紹",
      QR_NAME_LABELPRODUCT: "編輯產品標籤",
      QR_NAME_GOLDPRODUCT: "編輯黃金標籤",
      QR_COINS: "加密貨幣",
      QR_SHOP: "商店管理",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "上傳中心",
      PRICING: "二維碼資費",
      QR_CREATE_MODELS: "建立名片模型",
      QR_CREATE_BUSINESS_MODELS: "建立業務頁面模型",
      QR_CREATE_PRODUCT_MODEL: "建立產品卡模型",
      QR_CREATE_MENU_MODELS: "建立商店選單模型",
      QR_CREATE_SHOP_MODEL: "建立線上商店模型",
      MODELS_LIST: "二維碼模型類型",
      MODELS_LIST_EDIT: "編輯模型",
      MODELS_LIST_MENU_EDIT: "編輯選單模型",
      MODELS_LIST_BMODEL_EDIT: "編輯線上商店模型",
      NFC: "NFC卡",
      SUBMIT_FORM: "註冊博主",
      REQUEST_LIST: "博主列表",
      PURE_DATA: "未建立名片列表",
      AUTO_CREATE: "自動二維碼建立",
      QR_CREATE: "建立二維碼",
      HISTORY_REMINDER: "提醒監控",
      BOOK: "提醒監控",
      "visitCard_pro": "Pro 名片",
      clickyarseo: "Pro 链接",
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "付款方式",
      ORDER_NOTIFICATIONS: "訂單通知",
      DISCOUNT_CODE: "折扣碼",
      CART: "購物車",
      TABLE_MANAGEMENT: "桌台管理",
    },
    ERRORS: {
      INVALID_INPUT: "請輸入正確的值！",
      CART_SETTINGS_FAILED: "購物車設定失敗！",
    },
  },
  popup: {
    prepared_stores_title: "準備好的線上商店範例",
  },
  buttons: {
    reset_defaults: "重設預設資料",
    download_qr: "下載二維碼",
    cleardefaults: "清除預設資訊",
    select_prepared_store: "選擇準備好的線上商店",
  },
  stepper: {
    create_qr: "建立二維碼",
    products_info: "產品與資訊",
    content_settings: "內容設定",
    sales_settings: "銷售設定",
  },
  fields: {
    online_store_name: "線上商店名稱",
    qr_address: "二維碼地址",
    qr_address_hint: "輸入您的二維碼地址",
    online_sale: "線上銷售",
  },
  login_settings: "登入設定",
  shop_logo_and_images: "商店標誌與圖片",
  login_page_info: "登入頁面資訊",
  upload_banner: "上傳橫幅",
  create_product: "建立產品",
  special_sale: "特價銷售",
  ended: "已結束",
  blog: "部落格",
  services: "服務",
  pdf_gallery: "PDF圖庫",
  create_section: "建立區塊",
  achievements: "成就",
  team_members: "團隊成員",
  working_hours: "工作時間",
  saturday: "星期六",
  sunday: "星期日",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  we_will_be_different: "我們會與眾不同……",
  striving_for_excellence: "我們始終追求卓越 >>> 為您",
  online_store_ready_15_minutes: "您的線上商店15分鐘內準備就緒！",
  sales_management: "銷售管理",
  dear_customer_online_stores: "親愛的客戶，您也可以在我們其他線上商店購物：",
  divar_site: "Divar網站",
  digikala_site: "Digikala網站",
  basalam_site: "Basalam網站",
  torob_site: "Torob網站",
  emalls_site: "Emalls網站",
  copyright_qrland: "QR Land保留所有權利。",
  tehran_address: "德黑蘭，沙里亞蒂街，賽義德·漢丹橋後，漢丹巷6號",
  our_achievements: "我們的成就",
  customer_satisfaction: "客戶滿意度",
  lowest_returns: "最低退貨率",
  loyal_customer: "忠實客戶",
  shipped_orders: "已出貨訂單",
  visit_our_videos: "瀏覽我們的影片。",
  bringing_the_best: "我們為您帶來最好的……",
  feedback_important: "您的回饋對我們很重要",
  guide_us_with_feedback: "請透過回答以下問題指導我們提供更好的服務。",
  satisfied_with_quality: "您對商品品質滿意嗎？",
  evaluate_packaging_quality: "您如何評價包裝品質？",
  satisfied_with_variety: "您對商品多樣性滿意嗎？",
  benefited_from_discounts: "您是否從本店折扣中受益？",
  post_1: "貼文1",
  fast_order_delivery: "快速訂單交付",
  post_2: "貼文2",
  post_3: "貼文3",
  product_authenticity_guarantee: "產品正品保證",
  comfortable_purchase: "舒適購物",
  how_to_place_order: "如何下訂單？",
  add_to_cart: "只需將所需產品加入購物車。",
  how_to_register: "如何在網站註冊？",
  click_login_and_enter_code:
    "只需點擊「登入」按鈕，輸入手機號碼後輸入收到的簡訊驗證碼。",
  delivery_time: "註冊後訂單到達需要多久？",
  fastest_delivery: "您的訂單將盡快出貨。",
  shipping_cost: "運費是多少？",
  shipping_cost_order: "訂單運費",
  variable_shipping_cost: "運費因您的地址而異。",
  change_or_cancel_order: "註冊後可以更改或取消訂單嗎？",
  no_change_or_cancel: "不可以。無法更改或取消。",
  mrs_Safdarian: "薩夫達里安女士",
  invalid_address: "輸入的地址無效！",
  shop_page_created_success: "您的商店頁面已成功建立。",
  qr_creation_failed: "二維碼建立失敗！",
  server_error: "伺服器錯誤！",
  qr_card_updated_success: "您的名片已成功編輯。",
  qr_save_edit_failed: "儲存/編輯二維碼時出錯",
  your_feedback: "您的回饋",
  digital_marketing_strategy: "用我們的數位行銷策略師將您的公司引向正確軌道",
  wait_for_default_products: "請等待預設產品完全載入您的網站。",
  template_categories_saved: "範本類別已成功儲存。",
  template_products_saved: "範本產品已成功儲存。",
  template_products_save_failed: "儲存範本產品時出錯！",
  template_categories_save_failed: "儲存範本類別時出錯！",
  login_page_text: "登入頁面文字",
  persian_error: "文字必須是波斯語",
  number_error: "輸入資料不得為非數字或空白",
  english_error: "文字不得為非英語或空白",
  mixPerEng_error: "文字不得為非英語或非波斯語或空白",
  email_error: "輸入的電子郵件格式無效",
  mobile_error: "輸入的號碼格式無效",
  meliCode_error: "輸入的國碼格式無效",
  site_error: "輸入的網站格式無效",
  min_length_error: "輸入值不得小於{{min}}",
  max_length_error: "輸入值不得大於{{max}}",
  form_submitted_message: "您的表單已成功提交",
  required_fields_error: "未輸入必填值",
  headphone_title: "耳機",
  buy_button: "購買",
  day: "天",
  hour: "小時",
  minute: "分鐘",
  second: "秒",
  required_field_error: "{{fieldName}}為必填項",
  submit_request_button: "提交請求",
  request_submitted_success: "您的請求已成功註冊",
  feedback_submitted_success: "您的回饋已成功註冊",
  description_required_label: "描述（必填）",
  description_optional_label: "描述（選填）",
  description_hint: "請在此欄位輸入您想要的描述（至少3個字元）",
  footer: {
    position: "側邊",
    contactUs: "聯絡我們",
    aboutUs: "關於我們",
    firstShift: "第一班",
    secondShift: "第二班",
    startTime: "開始時間",
    endTime: "結束時間",
    features: "功能",
    partners: "合作夥伴",
    affiliates: "聯盟計劃",
    panels: "面板",
    supportTicket: "支援工單",
    inPersonServices: "面對面服務",
    liveChat: "線上聊天",
    faq: "常見問題",
    add_secondshift: "新增第二班",
    firstDate: "開始日期",
    endDate: "結束日期",
  },
  qr_management: "二維碼管理",
  restore_default_questions: "恢復預設問題",
  delete_all: "全部刪除",
  edit_question: "編輯問題",
  move_up: "上移",
  move_down: "下移",
  delete: "刪除",
  selected_question: "選中的問題",
  question: "問題",
  answer_type: "答案類型",
  excellent: "優秀",
  good: "良好",
  very_poor: "很差",
  response_optionality: "選填 / 必填回答",
  required: "必填",
  optional: "選填",
  add_new_question: "新增問題",
  satisfied_with_quality: "您對商品品質滿意嗎？",
  evaluate_packaging_quality: "您如何評價包裝品質？",
  satisfied_with_variety: "您對商品多樣性滿意嗎？",
  benefited_from_discounts: "您是否從本店折扣中受益？",
  suggestions_for_improvement: "您對改善本店購物體驗有何建議？",
  confirm_delete_question: "刪除選中的問題？",
  question_deleted_success: "問題已成功刪除。",
  question_delete_failed: "刪除問題時出錯！",
  confirm_delete_all_questions: "您確定要刪除所有問題嗎？",
  questions_deleted_success: "問題已成功刪除。",
  questions_delete_failed: "刪除問題時出錯！",
  invalid_input: "請輸入正確的值！",
  operation_failed: "操作失敗！",
  question_number: "問題{number}？",
  card_subtitle: "只需輸入您想要的圖片的故事，AI將為您建立。",
  upgrade_label: "附加",
  free: " - 免費",
  language_select: "選擇用於編寫請求文字的語言",
  image_size: "圖片大小",
  prompt_label: "請求文字",
  prompt_placeholder: "描述您想要的圖片……",
  generate_image: "生成圖片",
  regenerate_image: "生成新圖片",
  save_image: "儲存圖片",
  save_image_subtitle: "僅儲存上方顯示的圖片。",
  size_items: {
    "16:9": "16:9（橫向）",
    "9:16": "9:16（縱向）",
    "1:1": "1:1（方形）",
  },
  lang_items: {
    fa: "Fa | 波斯語",
    en: "En | 英語",
    ar: "Ar | 阿拉伯語",
  },
  rules: {
    empty: "至少輸入3個字元！",
    spell_checker: "輸入的文字必須是{language}語言！",
  },
  ERRORS: {
    VpnDetectedTitle: "請關閉VPN",
    VpnDetectedSubtitle: "這有助於系統更好地運行並為您提供更好的體驗。",
  },
  errors: {
    VpnDetectedTitle: "請關閉VPN",
    VpnDetectedSubtitle: "這有助於系統更好地運行並為您提供更好的體驗。",
    invalid_size: "請正確輸入寬度和高度！",
    image_generation_error: "圖片生成錯誤",
    image_upload_error: "圖片上傳錯誤！",
    service_unavailable: "無法使用此服務 - 從伺服器載入資料時發生錯誤",
    qr_address_taken: "此QR地址已被使用",
  },
  add_working_time: "新增工作時間",
  selected_day: "選中的日子",
  range_name: "時間範圍名稱",
  add: "新增",
  first_shift: "第一班",
  second_shift: "第二班",
  start_time: "開始時間",
  end_time: "結束時間",
  date_range: "日期範圍",
  all_week_days: "一週的所有日子",
  saturday_to_wednesday: "星期六至星期三",
  saturday_to_thursday: "星期六至星期四",
  work_week: "一週的所有日子（節假日除外）",
  feedbacks: "回饋",
  failed_retrieve_feedback: "獲取回饋失敗！",
  province: "省份",
  search_city_placeholder: "搜尋您想要的城市名稱。",
  search_city_label: "城市搜尋",
  welcome: "歡迎使用我們的應用程式",
  description: "這是一個多語言應用程式。",
  soon: "即將推出",
  beta_version: "測試版",
  defaults_cleared_success: "預設資料已成功清除",
  defaults_reset_success: "預設資料已成功重設",
  select_navigator_after_location_click: "點擊位置後，選擇所需的導航器",
  no_address_selected: "未選擇地址",
  no_location_selected: "未選擇位置",
  region: "地區",
  api_unauthorized: "認證錯誤：無效的API金鑰",
  location_not_found: "位置未找到",
  addCategory: "添加新類別",
  editCategory: "編輯類別",
  deleteCategory: "刪除選定的類別？",
  addProduct: "添加新產品",
  saveProducts: "選擇默認產品",
  addSubCategory: "添加子類別",
  product: "產品",
  categoryName: "類別名稱",
  subCategoryName: "子類別名稱",
  confirmDeleteProduct: "是否從類別中移除產品？",
  successMessages: {
    categorySaved: "類別保存成功。",
    productSaved: "產品保存成功。",
    productDeleted: "產品刪除成功。",
  },
  errorMessages: {
    saveCategoryFailed: "保存類別出錯！",
    saveProductFailed: "保存產品出錯！",
    deleteCategoryFailed: "刪除類別出錯！",
  },
  add_edit_categories: "添加/編輯類別",
  copy_category: "複製類別",
  product: "產品 {point}",
  copy_product: "複製產品",
  add_edit_products: "添加/編輯產品",
  edit_category: "編輯類別",
  category_name: "類別名稱",
  edit_subcategory: "編輯子類別",
  subcategory_name: "子類別名稱",
  add_new_category: "添加新類別",
  store_management: "商店管理",
  manage_products: "產品管理",
  products_export: "下載產品",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "上傳Excel檔案",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "將您的Excel檔案拖到這裡或",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "選擇它",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "以上傳",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "請僅上傳Excel檔案（.xlsx）",
  "GENERAL.SUBMIT": "提交",
  "GENERAL.CANCEL": "取消",
  "GENERAL.SUCCESSFULLY_ADDED": "產品上傳成功",
  SUCCESSFULLY_DOWNLOADED: "產品下載成功",
  "GENERAL.ERROR": "發生錯誤",
  EditSubCategoty: "編輯子類別",
  create: "創建",
  save_changes: "保存更改",
  buy_button_settings: "購買按鈕設定",
  image: "圖片",
  color: "顏色",
  title: "標題",
  price: "價格",
  discount: "折扣",
  percent: "百分比",
  amount: "金額",
  brand: "品牌",
  inventory: "庫存",
  inventory_hint: "留空 = 無限訂單數量",
  order_limit: "每訂單最大數量",
  order_limit_hint: "留空 = 無限制",
  packing_price: "包裝費用",
  packing_price_hint: "適用於外部訂單（快遞/現場取貨）。",
  description: "描述",
  options: "選項",
  product_features: "產品特徵",
  field_required: "必填欄位。",
  min_length: "至少需要3個字符。",
  product: "產品",
  default_brand: "蘋果",
  product_added_success: "產品添加成功",
  product_added_error: "添加產品出錯",
  whole_categories: "(所有類別)",
  add_select_category: "添加/選擇類別",
  select_default_category: "選擇默認類別",
  deleted_product: "刪除產品",
  confirm_delete_prooduct: "是否從類別中移除產品？",
  please_wait_store_product: "產品正在保存，請等待...",
  saved_product_success: "產品保存成功。",
  error_in_store: "保存出錯",
  delete_category: "刪除類別",
  confirm_delete_category: "類別刪除成功。",
  error_delete_category: "刪除類別出錯！",
  productOptionEditor: {
    tabs: {
      color: "顏色",
      size: "尺寸",
      count: "數量",
      weight: "重量",
      type: "類型/性別",
    },
    fields: {
      count: "數量",
      max_order: "最大訂單數量",
      price: "價格",
      discount: "折扣",
      color: "顏色",
      color_name: "顏色名稱",
      inventory: "庫存",
      size: "尺寸",
      type: "類型/性別",
      weight: "重量",
    },
    actions: {
      delete: "刪除",
      add_location: "添加選項",
    },
  },
  extraSubProducts: {
    feature: "特徵",
    name_label: "名稱",
    name_placeholder: "示例：額外醬料 / 額外面包",
    price_label: "價格",
    price_hint: "留空 = 免費附加。",
    price_placeholder: "示例：水，類型（例如雞胸肉/雞腿）",
    add_subproduct: "添加附加產品",
  },
  error_selected_category: "選擇類別出錯！",
  suggestinput: {
    title: "選擇表情符號",
    aboutUs: "關於我們",
    error: "錯誤",
    errorMessage: "請充值信用額並重試。",
    generateText: "AI文本建議",
    emoji: "表情符號",
    errorMessage_400: "創建'關於我們'文本出錯。請重試。",
    errorMessage_403: "創建'關於我們'文本出錯。請購買套餐並重試。",
  },
  togetherai: {
    buy_package: "購買套餐",
    tax_notice: "套餐價格將添加10%增值稅！",
    package: "套餐",
    rial: "里亞爾",
    buy_button: "購買！",
    discount_label: "折扣碼",
    submit_discount: "兌換",
    success_message: "您的QR已成功升級。",
    error_insufficient_funds: "檢查您的信用額並稍後重試。",
    error_upgrade: "升級QR出錯！",
    error_title: "錯誤",
    success_title: "成功",
  },
  category_not_found: "類別未找到！",
  create_upload_category: "創建並上傳類別",
  add_subcategory: "添加子類別",
  error_upload_m_video: "上傳視頻出錯（可能訪問受限）。",
  info_show_video: "點擊'更多'顯示更多。",
  error_not_valid_guide_id: "無效的指南ID！",
  error_give_guide_info: "獲取指南信息出錯！",
  info_success_saved: "保存成功",
  error_add_new_guide: "添加新指南出錯",
  popup: {
    details: "詳情",
    guide_images: "指南圖片",
    guide_videos: "指南視頻",
    faq: "常見問題",
    no_title: "無標題",
    no_content: "無內容顯示",
    no_questions: "無問題顯示",
    video_error: "上傳視頻出錯（可能訪問受限）",
    no_answer: "無答案",
    question_no_title: "無標題問題",
    default_title: "指南",
  },
  productPicker: {
    select_default_product: "選擇默認產品",
    search: "搜索",
    select_all_products: "選擇所有產品",
    back: "返回",
    no_products_in_category: "此類別中無產品！",
    products_error: "加載產品出錯！",
    retry: "重試",
    items_per_page: "每頁項目",
    root_breadcrumb: "/",
  },
  end_date: "結束日期",
  filters: {
    userType: {
      legal: "法人實體",
      individual: "個人",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "廣告牌",
      tablighNegar: "TablighNegar",
      unknown: "未知",
    },
    qrType: {
gift: "回憶相框",
instagram: "Instagram",
visitCard: "電子名片",
Business: "個人 / 企業",
Commericial: "商業 / 辦公綜合體網站",
qrlink: "QR連結",
labelproduct: "產品標籤",
goldLabel: "黃金標籤",
bShop: "商店",
SocialMedia: "社群媒體",
VideoGallery: "影片圖庫",
PhotoGallery: "照片圖庫",
voiceGallery: "音訊圖庫",
consultationQr: "申請表單",
application: "應用程式",
feedbackGallery: "使用者回饋",
voiceGalleryPro: "專業音訊圖庫",
singleProduct: "產品介紹",
menu: "選單",
appointment: "預約",
insurance: "保險",
text: "文字",
luck_wheel: "幸運轉盤",
pdfgallery: "PDF圖庫",
productpro: "Pro產品介紹",
multicard: "多卡片",
catalog: "型錄",
visitCard_pro: "Pro電子名片",
clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "天",
      expired: "已過期",
    },
    numericPersianNumber: {
      thousand: "千",
      million: "百萬",
    },
    dateString: {
      at: "在",
    },
    messages: {
      pleaseLogin: "請登錄",
      invalidPhone: "無效電話號碼",
      copied: "已複製",
    },
  },
  nextButton: "下一個",
  previousButton: "上一個",
  rowsPerPageText: "每頁行數",
  noDataText: "無數據顯示",
  placeholderSearch: "搜索..",
  set_qr: "QR已註冊",
  numbers: "數字",
  enter_param_product: "正確輸入產品數據！",
  instagram_hint: "輸入您的Instagram",
  whatsapp_hint: "輸入您的WhatsApp",
  telegram: "Telegram",
  telegram_hint: "輸入您的Telegram",
  userpicker: {
    select_user: "選擇用戶",
    choice_users: "選擇用戶",
    id: "ID",
    phone_number: "手機號碼",
    date_created: "創建日期",
    info_edit: "編輯信息",
    name_family: "姓名",
    position: "職位和級別",
    phone: "電話",
    discription: "描述",
  },
  search_product: "搜索產品",
  search_name_product: "搜索產品名稱",
  currency: "里亞爾",
  headers: {
    index: "順序",
    gallery: "圖片",
    id: "ID",
    name: "名稱",
    brand: "品牌",
    price: "金額",
    discount_amount: "折扣",
  },
  search_categories: "在類別中搜索",
  delete_all: "刪除全部",
  select_category: "選擇類別",
  currency1: "伊朗里亞爾",
  features: "特徵",
  product_sp: {
    edit: "編輯",
    back: "返回",
    save: "保存",
    add_product_to_special_category: "填寫欄位以將產品添加到特殊類別",
    inventory: "庫存",
    discount: "折扣",
    max_per_customer: "每客戶最大",
    max_per_order: "每訂單最大",
    expires_at: "到期日期",
    field_cannot_be_empty: "欄位不能為空。",
    please_enter_correctly: "請正確填寫！",
    currency: "伊朗里亞爾",
  },
  selectproduct: "選擇產品",
  section: {
    edit_part: "編輯部分",
    title: "標題",
    position_text: "文本位置",
    add_video: "添加視頻",
    text: "文本",
    address_video: "視頻URL",
    position_left: "左側",
    position_right: "右側",
    tab_edit_button: "編輯按鈕",
    tab_content: "部分內容",
  },
  name_shopping: "商店名稱",
  hint_shopping: "輸入您的商店名稱。",
  title_discount: "折扣標題",
  hint_discount: "輸入您的折扣標題。",
  hint_mount_discount: "下次訂單20%折扣。",
  label_discount: "輸入折扣金額",
  give_discount: "獲取折扣碼",
  give_copon: "獲取優惠券",
  enter_copon: "輸入優惠券",
  hint_phone: "輸入您的電話號碼。",
  label_phone: "電話號碼",
  hint_condition_discount: "描述折扣條件..",
  label_discription_discount: "折扣描述",
  add_info_discount: "添加額外信息：",
  enter_address_discount: "輸入您的地址。",
  address_discount: "地址",
  edit_feedback: "編輯反饋",
  select_type_replay: "選擇回復類型",
  field_discription: "描述欄位",
  messages_discription: "啟用以向用戶顯示描述欄位",
  number_char: "字符數必須在3到50之間！",
  search: "搜索",
  no_videos_found: "未找到視頻！",
  upload_video_prompt: "使用視頻上傳區域添加檔案",
  delete_success: "刪除成功。",
  tabs: {
    qr_view: "QR視圖",
    preview: "預覽",
    ready_video: "準備好的視頻",
    video_gallery: "視頻畫廊",
    link: "鏈接",
    video_upload: "上傳視頻",
  },
  consultation: {
    name: "名字",
    surname: "姓氏",
    phone: "手機號碼",
    nationalId: "國家ID號碼",
    nationalIdAuthenticate: "驗證國家ID",
    nationalIdCorrect: "檢查國家ID號碼有效性",
    mail: "電子郵件",
    address: "地址",
    location: "位置",
    custom: "自定義",
    customLabel: "標題",
    customOptions: "選項",
    optional: "可選",
    require: "必填",
    description: "描述",
  },
  add_section: "添加部分",
  add_new_text_section: "您被熱烈邀請到QR-Land的智能數字世界。",
  btn_title_section: "免費註冊",
  shop: {
    step_products_and_info: "產品與信息",
    online_store_name: "在線商店名稱",
    qr_address: "QR地址",
    qr_address_hint: "輸入您的QR地址",
    online_sale: "在線銷售",
    step_content_settings: "內容設定",
    step_sale_settings: "銷售設定",
    download_qr: "下載QR",
    login_settings: "登錄設定",
    store_logo_images: "商店標誌和圖片",
    login_page_info: "登錄頁面信息",
    upload_banner: "上傳橫幅",
    user_info: "用戶信息",
    create_product: "創建產品",
    special_sale: "特價銷售",
    add_social_media: "添加社交媒體",
    blog: "博客",
    services: "服務",
    faq: "常見問題",
    photo_gallery: "照片畫廊",
    video_gallery: "視頻畫廊",
    pdf_gallery: "PDF畫廊",
    feedback: "反饋",
    countdown: "倒計時",
    request_form: "請求表單",
    create_section: "創建部分",
    achievements: "成就",
    team_members: "團隊成員",
    working_hours: "營業時間",
    error_saving_content: "保存內容設定出錯！",
    success_edit_store: "商店頁面編輯成功。",
    post_1: "帖子1",
    logo: "標誌",
    background_image: "背景圖片",
  },
  discount_obj: {
    quantity: "數量",
    create_edit_code: "創建/編輯折扣碼",
    coding_type_label: "創建類型",
    coding_type_single: "單個",
    coding_type_group: "組",
    status_label: "狀態",
    status_active: "活躍",
    status_deactivate: "已停用",
    discount_code: "折扣碼",
    discount_type: "折扣類型",
    discount_type_percent: "百分比",
    discount_type_fixed: "固定金額",
    discount_value: "折扣值",
    discount_limit: "折扣限制",
    no_limit: "無限制",
    tab_create_discount: "創建折扣碼",
    tab_settings: "設定",
    success_create: "折扣碼創建成功",
    success_edit: "折扣碼編輯成功",
    error_value_empty: "折扣值不能為空！",
    error_start_time: "未選擇開始時間！",
    error_end_time: "未選擇結束時間！",
    error_same_time: "開始和結束時間不能相同",
  },
  personnel: {
    team_members: "選定的團隊成員",
    add_team_member: "添加團隊成員",
    default_position: "職位和級別",
    default_phone: "電話號碼",
    default_full_name: "全名",
    default_description: "Lorem Ipsum只是印刷行業的虛擬文本，設計師使用數百年",
  },
  discount_settings: {
    function_type: {
      title: "折扣功能",
      all_shopping_cart: "購物車總金額",
      special_products: "特殊產品",
      special_categories: "特殊類別",
    },
    basket_condition: {
      title: "購物車條件",
      no_conditions: "無條件",
      minimum_shopping: "最小購物車金額",
      minimum_product: "購物車最小產品數",
      maximum_shopping: "最大購物車金額",
      maximum_product: "購物車最大產品數",
    },
    user_settings: {
      title: "用戶設定",
      all_user: "所有用戶",
      group: "用戶組",
      special: "特殊用戶",
    },
    limitation_use: {
      title: "使用限制",
      no_limitations: "無限制",
      discount_code: "折扣碼使用次數",
      user: "每用戶使用次數",
    },
    start_time: {
      title: "折扣開始日期",
      no_time_selected: "未選擇開始時間",
    },
    end_time: {
      title: "折扣結束日期",
      no_time_selected: "未選擇結束時間",
    },
  },
  counterService: {
    typeLabel: "顯示類型",
    number: "數字",
    percent: "百分比",
    iconLabel: "圖標",
    counterLabel: "值",
    linkLabel: "鏈接",
    nameLabel: "標題",
    addButton: "添加成功",
    successful: {
      added: "項目添加成功",
      removed: "項目移除成功",
      movedUp: "項目上移成功",
      movedDown: "項目下移成功",
    },
  },
  qrUsersList: {
    customersList: "客戶列表",
    orders: "訂單",
    addresses: "地址",
    hasAssistantsMobile_hint: "選擇手機",
    invalidPhone: "輸入的手機號碼無效",
    validation: {
      nameRequired: "姓名必填",
      nameMinLength: "姓名至少需要2個字元",
      familyRequired: "姓氏必填",
      familyMinLength: "姓氏至少需要2個字元",
    },
    addUser: "新增使用者",
    registerOnline: "啟用線上註冊",
    usersColumns: {
      id: "ID",
      name: "名字",
      family: "姓氏",
      mobile: "手機",
      subscriptionId: "訂閱ID",
      ordersCount: "訂單數",
      lastLogin: "最後登錄",
      status: "狀態",
      activeUser: "活躍用戶",
      none: "-",
      actions: "操作",
      buttons: {
        info: "客戶數據",
        sendSms: "發送短信",
        history: "歷史",
        addresses: "地址",
        orders: "訂單",
      },
    },
    orderColumns: {
      orderId: "訂單號",
      customerName: "客戶姓名",
      mobile: "手機",
      paymentMethod: "支付方式",
      shippingMethod: "配送方式",
      orderAmount: "訂單金額",
      orderTime: "訂單時間",
      status: "狀態",
      currency: "里亞爾",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "地址標題",
      name: "名字",
      family: "姓氏",
      mobile: "電話",
      address: "地址",
      zipCode: "郵編",
      number: "門牌號",
      unit: "單元",
    },
    shippingType: {
      courier: "快遞",
      reservation: "桌位預訂",
      place: "現場取貨",
      none: "-",
    },
    paymentType: {
      online: "在線支付",
    },
    perPage: "每頁條目",
    search: "搜索",
    sortColumn: "排序列",
    sortDirection: "排序方向",
    sortDirectionDesc: "降序",
    sortDirectionAsc: "升序",
    noStatus: "未找到狀態",
    status: {
      all: "全部",
      active: "活躍",
      inactive: "不活躍",
    },
    fetchError: "加載用戶數據出錯",
  },
  listCardHeader: {
    clear_filters: "清除過濾器",
    group_qr_renewal: "批量QR碼續訂",
    select_desired_duration: "選擇所需時長",
    total_count: "總數",
    final_amount: "最終金額",
    ten_percent_vat_will_be_added: "將添加10%增值稅",
    pay_and_upgrade: "支付並升級",
    no_tariff_for_this_period: "此期間無資費",
    one_month_renewal: "1個月續訂",
    three_month_renewal: "3個月續訂",
    six_month_renewal: "6個月續訂",
    one_year_renewal: "1年續訂",
    selected: "已選",
    view: "查看",
    details: "詳情",
    total_amount: "總金額",
    discount: "折扣",
    final_amount_with_discount: "折扣後最終金額",
    add_qr: "添加QR",
    select_all: "全選",
    actions: "操作",
    filter: "過濾",
    type_filter: "類型過濾",
    start_from: "從...開始",
    search: "搜索",
    id_search: "ID搜索",
    filter_user: "用戶過濾",
    sort: "排序",
    send_sms: "發送短信",
    selected_pattern: "選定模式：",
    send: "發送",
    newest: "最新",
    oldest: "最舊",
    most_visited: "最多訪問",
    least_visited: "最少訪問",
    pause: "暫停",
    bulk_download: "批量下載",
    activate: "激活",
    deactivate: "停用",
    error_loading_card: "加載卡片數據出錯！",
    error_fetching_prices: "獲取價格出錯！",
    error_payment: "支付出錯！",
    sms_success: "短信發送成功",
    generic_error: "發生錯誤！",
  },
  headerTypeFilter: {
    qr_model: "QR模型",
    all_qr_models: "所有QR模型",
  },
  menuOrderFactor: {
    order_invoice: "訂單發票",
    total: "總計",
    tax: "稅",
    shipping_cost: "運費",
    packing_cost: "包裝費",
    discount: "折扣",
    final_total: "最終總計",
    currency: "里亞爾",
    titles: {
      default_title: "標準訂單",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "在列表中搜索",
    search: "搜索",
    start_from: "從...開始",
  },
  headerStatusFilter: {
    all_qr_codes: "所有QR碼",
    active_qr_codes: "活躍QR碼",
    inactive_qr_codes: "不活躍QR碼",
    expiring_qr_codes: "即將過期QR碼",
    expired_qr_codes: "已過期QR碼",
  },
  qrOrdersList: {
    title: "訂單列表",
    orderColumns: {
      index: "訂單",
      id: "訂單號",
      customerName: "客戶姓名",
      mobile: "手機",
      paymentType: "支付類型",
      shippingType: "配送類型",
      price: "訂單金額",
      createdAt: "訂單時間",
      status: "狀態",
      actions: "操作",
    },
    productsColumns: {
      productId: "產品ID",
      image: "圖片",
      productName: "產品名稱",
      unitPrice: "單價",
      quantity: "數量",
      totalPrice: "總價",
    },
    actions: {
      products: "訂單列表",
      print: "打印訂單",
      share: "分享訂單",
      status: "更改狀態",
    },
    shippingType: {
      courier: "快遞",
      reservation: "桌位預訂",
      place: "現場取貨",
      post: "郵寄",
      unknown: "-",
    },
    paymentType: {
      online: "在線支付",
      place: "現場支付",
      unknown: "-",
      card2card: "卡对卡支付"
    },
    status: {
      all: "全部",
      pending: "待支付",
      accepted: {
        place: "現場支付",
        paid: "已支付",
      },
      delivered: "已交付",
      rejected: "支付失敗",
    },
    factorTitle: "訂單發票",
    printFactor: "打印發票",
    fetchError: "加載數據出錯",
    statusChanged: "狀態更改成功",
    statusChangeError: "更改狀態出錯",
    currency: "里亞爾",
    perPage: "計數",
    search: "搜索",
    noStatus: "無狀態",
    loading: "加載中...",
    noShippingType: "無配送類型",
    noPaymentType: "無支付類型",
    sortColumn: "排序列",
    sortDirection: "排序方向",
    sortDirectionDesc: "降序",
    sortDirectionAsc: "升序",
    selectNewStatus: "選擇新狀態",
    changeStatusTitle: "更改狀態",
    linkCopied: "鏈接已複製。",
  },
  qrUserTransfer: {
    title: "所有權轉移",
    radioLabels: {
      userTransfer: "轉移給他人",
      givingAccess: "授予訪問權",
    },
    inputLabels: {
      phone: "個人手機號碼",
    },
    hints: {
      addNumber: "按Enter或+添加",
      addNumberStep2: "按Enter或+添加",
    },
    buttons: {
      transfer: "轉移",
      giveAccess: "授予訪問權",
      back: "返回",
      saveChanges: "保存更改",
      cancel: "取消",
        "add": "新增"

    },
    tooltips: {
      deleteAccess: "移除訪問權",
    },
    subtitles: {
      accessList: "授權用戶列表：",
      selectPermissions: "選擇權限：",
    },
    permissionList: {
      edit_name: "編輯服務名稱",
      edit_link: "編輯鏈接",
      edit_info: "編輯信息",
      edit_design: "編輯QR設計",
      edit_settings: "編輯QR設定",
      toggle_access: "啟用/禁用訪問",
      view_customers: "查看客戶列表",
      view_orders: "查看訂單列表",
    },
    messages: {
      invalidPhone: "無效電話號碼",
      duplicatePhone: "不允許重複號碼",
      updateAccessSuccess: "訪問更新成功。",
      updateAccessError: "更新出錯：{message}",
      deleteAccessSuccess: "訪問移除成功。",
      deleteAccessError: "移除出錯：{message}",
      fetchAccessError: "加載出錯：{message}",
      transferSuccess: "QR轉移成功。",
      transferError: "轉移出錯：{message}",
      giveAccessSuccess: "設定成功。",
      giveAccessError: "設定出錯：{message}",
      confirmDeleteAccess: "真的移除此人的訪問權嗎？",
    },
  },
  form: {
    form_download: "接收的表單",
    form_add: "添加表單",
    formdownload: "接收的表單",
    create_at: "創建於：",
    shown: "顯示",
    nogiveform: "您沒有接收的表單",
    back: "返回",
    invalid_date: "無效日期",
    select_date: "選擇日期",
    select: "選擇",
    clear: "清除",
    now: "現在",
  },
  dsBasketCondition: {
    title: "最小購物車條件",
    items: {
      NoConditions: "無條件",
      MinimumShopping: "最小購物車金額",
      MinimumProduct: "購物車最小產品數",
      MaximumShopping: "最大購物車金額",
      MaximumProduct: "購物車最大產品數",
    },
  },
  dsUserSettings: {
    title: "最小購物車條件",
    groupTitle: "用戶，誰",
    specialTitle: "用戶",
    labels: {
      minimumCart: "最小購物車條件",
      users: "用戶",
    },
    items: {
      AllUser: "所有用戶",
      group: "用戶組",
      special: "特殊用戶",
    },
    groupItems: {
      Order: "已購買",
      noOrder: "尚未購買",
    },
  },
  qrAddressUpdate: {
  title: "編輯地址",
  labels: {
    address: "QR 地址",
  },
  hints: {
    allowedChars: "僅允許使用英文字母、數字、連字號 (-) 和底線 (_)",
  },
  buttons: {
    removeInvalidChars: "移除無效字元",
  },
  errors: {
    minLength: "至少需要 3 個字元",
    invalidChars: "無效字元！只能使用英文字母、數字、- 和 _。",
    invalidAddress: "輸入的地址無效",
    updateFailed: "更新地址失敗",
  },
  successMessage: "地址更新成功",
  warning: "警告",
  warningMessage: "變更地址後，先前的連結將無法使用。",
  savePrompt: "確定要儲存此變更嗎？",
},
  dsFunctionType: {
    title: "折扣適用於",
    productListTitle: "產品列表",
    categoryListTitle: "類別列表",
    labels: {
      applyDiscount: "應用折扣到",
      category: "類別",
    },
    items: {
      AllShoppingCart: "購物車總金額",
      SpecialProducts: "特殊產品",
      SpecialCategories: "特殊類別",
    },
  },
  dsLimitationUse: {
    title: "使用限制",
    discountCodeTitle: "碼使用次數",
    userTitle: "每用戶使用次數",
    labels: {
      limitation: "限制",
      usage: "使用",
      user: "用戶",
    },
    items: {
      NoLimitations: "無限制",
      DiscountCode: "折扣碼使用次數",
      User: "每用戶使用次數",
    },
  },
  ManageHourLimitQr: {
    noLimit: "無限制",
    dateLimit: "日期限制",
    timeLimit: "時間限制",
    startDate: "開始日期",
    endDate: "結束日期",
    selectDate: "選擇日期",
    startTime: "開始時間",
    endTime: "結束時間",
  },
  discount_percent_range: "折扣必須在0到100%之間",
  discount_price_range: "折扣必須在0到{max}之間",
  invalid_number: "僅輸入數字",
  min_order_cart: "最小訂單值",
  preparation_time: "準備時間（分鐘）",
  delivery_time: "交付時間（分鐘）",
  max_product_in_order: "每訂單最大產品數",
  max_order_by_person: "每人最大訂單數",
  send_by_courier_price: "快遞費用",
  vat: "稅率",
  send_by_post: "郵寄費用",
  online_pay: "在線支付",
  pay_in_person_place: "現場支付",
  in_place: "現場取貨",
  table_booking_ability: "桌位預訂",
  send_by_courier: "快遞交付",
  vat_switch: "稅",
  invalid_number: "僅輸入數字",
  positive_number: "數字必須為正",
  vat_range: "稅率必須在0到100%之間",
  sort_column: "排序列",
  direction_sort: "排序方向",
  listFeedbackUser: {
    no_questions: "您沒有反饋收集問題",
    add_feedback_prompt: "在'添加'選項卡中創建新反饋",
    question_label: "問題",
    show_answers: "顯示答案",
    back_button: "返回",
    no_feedback: "無反饋可用！",
    user_opinion: "用戶意見",
    score_label: "評分",
  },
  manageDiscount: {
    createNewDiscount: "創建新折扣碼",
    copy: "複製",
    row: "行",
    id: "ID",
    discountCode: "折扣碼",
    usageLimit: "使用限制",
    used: "已用",
    manage: "管理",
    edit: "編輯",
    delete: "刪除",
    sendSms: "發送短信給目標組",
    copySuccess: "折扣碼已複製",
    copyError: "複製出錯",
    deleteSuccess: "折扣碼已刪除",
    deleteError: "刪除折扣碼出錯",
    smsSuccess: "折扣碼已發送給目標組",
    smsError: "發送出錯",
  },
  manageTableReservation: {
    table: "桌子",
    number: "桌子 {num}",
    add_table: "添加桌子",
    complete_info_for_customer: "填寫顯示給客戶的信息",
    select_image: "選擇圖片",
    table_name_number: "桌子名稱/號碼",
    number_of_seats: "座位數",
    type: "類型",
    reservation_cost: "預訂費用",
    enter_table_name: "輸入桌子名稱/號碼",
    table_type: "桌子",
    couch_type: "沙發",
    gazebo_type: "涼亭",
  },
  create_menu: {
    data: {
      visitName_label: "訪問名稱",
      organizationName: "大型快餐連鎖",
      subOrgan: "與我們一起嘗試最好的快餐味道",
      aboutUs:
        "大型快餐 – 以質量和對客戶的尊重，我們提供最好的。\n質量是我們的原則。\n在快餐領域，我們用我們的特殊三明治為快速餐食世界引入了新味道。\n我們每天準備在行政活動、生日等場合為您服務...",
      copyright: "本網站所有權利屬於Terminal Advertising。",
      product: {
        title: "產品",
        pizzas: "披薩",
        pizza_roast_beef: "烤牛肉披薩",
        pizza_roast_beef_desc: "🤩 意大利披薩配牛肉",
        pizza_roast_beef_ingredients:
          "意大利披薩底30厘米，100克牛肉末，蘑菇，辣椒，黑橄欖",
        pizza_chicken_mushroom: "雞肉蘑菇披薩",
        pizza_chicken_mushroom_desc: "🍕 經典40厘米",
        pizza_chicken_mushroom_ingredients:
          "新鮮Pizzara番茄醬，巴氏殺菌奶酪，雞柳，蘑菇，山百里香",
        pizza_meat_mushroom: "肉蘑菇披薩",
        pizza_meat_mushroom_desc: "🥰 牛肉末和蘑菇披薩",
        pizza_meat_mushroom_ingredients:
          "新鮮Pizzara番茄醬，巴氏殺菌奶酪，牛里脊肉末，蘑菇，山百里香，2人份（29厘米）355,000托曼，1人份（22厘米）216,000托曼",
        pizza_veggie: "素食披薩",
        pizza_veggie_desc: "🍕 美國素食披薩",
        pizza_veggie_ingredients:
          "美國披薩底，甜玉米，蘑菇，橄欖，西紅柿，洋蔥，辣椒，披薩奶酪",
        pizza_special: "特殊披薩",
        pizza_special_desc: "美國特殊披薩",
        pizza_special_ingredients:
          "美國披薩底，調味牛肉末，漢堡混合牛肉和雞肉80%，莫扎里拉混合，特殊醬，辣椒，蘑菇，1人份無醬",
        pizza_bolognese: "博洛尼亞披薩",
        pizza_bolognese_desc: "(1人份) 披薩底23厘米 🤌",
        pizza_bolognese_ingredients:
          "牛肉末，莫扎里拉，蘑菇，辣椒，甜玉米，切片黑橄欖",
        pizza_pepperoni: "佩珀羅尼披薩",
        pizza_pepperoni_desc: "(1人份) 披薩底23厘米",
        pizza_pepperoni_ingredients:
          "意大利披薩底，佩珀羅尼80%，馬里納拉醬，特殊披薩奶酪",
        pizza_bacon: "培根披薩",
        pizza_bacon_desc: "(1人份) 披薩底23厘米 💥",
        pizza_bacon_ingredients:
          "意大利披薩底，馬里納拉醬，特殊披薩奶酪，培根混合牛肉和雞肉90%，蘑菇，橄欖，辣椒",
        pizza_mixed: "混合披薩",
        pizza_mixed_desc: "(1人份) 披薩底23厘米 🤭",
        pizza_mixed_ingredients:
          "漢堡混合牛肉和雞肉末，薩拉米，牛肉末，蘑菇，橄欖，辣椒，披薩奶酪，特殊醬",
        pizza_american_steak: "美國牛排披薩",
        pizza_american_steak_desc: "(1人份) 23厘米 💥",
        pizza_american_steak_ingredients:
          "美國披薩底，牛肉塊，蘑菇，披薩奶酪，芝麻",
        burgers: "漢堡",
        cheeseburger: "芝士漢堡",
        cheeseburger_desc: "🤩 配薯條",
        cheeseburger_ingredients:
          "2個牛肉漢堡餅每個150克，特殊醬，高達奶酪，腌黃瓜，生菜，西紅柿",
        hamburger: "漢堡",
        hamburger_desc: "😍 純牛肉配特殊醬",
        hamburger_ingredients:
          "牛肉漢堡餅150克，腌黃瓜，生菜，特殊醬，西紅柿，Mac麵包，1人份醬",
        chicken_burger: "雞肉漢堡",
        chicken_burger_desc: "烤雞配奶酪",
        chicken_burger_ingredients:
          "150克烤雞胸，奶酪，西紅柿，腌黃瓜，生菜，Mac麵包，特殊醬",
        spice_burger: "辣漢堡",
        spice_burger_desc: "牛肉配辣醬",
        spice_burger_ingredients:
          "牛肉漢堡餅130克，辣醬，生菜，西紅柿，Mac麵包，特殊辣醬",
        double_burger: "雙層漢堡",
        double_burger_desc: "牛肉150克",
        double_burger_ingredients:
          "2個手工牛肉餅每個150克，披薩奶酪，焦糖醬，生菜，紅捲心菜，白特殊醬，圓麵包",
        royal_burger: "皇家漢堡",
        royal_burger_desc: "150克牛肉 🍔",
        royal_burger_ingredients:
          "手工牛肉餅150克，披薩奶酪，5片薩拉米，焦糖醬，生菜，紅捲心菜，白特殊醬，圓麵包",
        mushroom_burger: "蘑菇漢堡",
        mushroom_burger_desc: "牛肉150克",
        mushroom_burger_ingredients:
          "手工牛肉餅150克，蘑菇，焦糖醬，生菜，紅捲心菜，白特殊醬，圓麵包，莫扎里拉",
        mashroom_burger: "蘑菇漢堡",
        mashroom_burger_desc: "100%烤牛肉 🤩",
        mashroom_burger_ingredients:
          "手工100%烤牛肉餅，薯條，西紅柿，生菜，腌黃瓜，蘑菇醬，圓麵包",
        fried_burger: "炸漢堡",
        fried_burger_desc: "100%烤和炸牛肉 👌",
        fried_burger_ingredients:
          "手工100%烤和炸牛肉餅，150克薯條，西紅柿，生菜，腌黃瓜，特殊醬，圓麵包",
        fried: "炸的",
        fried_chicken: "炸雞",
        fried_chicken_desc: "😍 3塊炸雞",
        fried_chicken_ingredients:
          "3塊炸雞，120–150克薯條，100–120克涼拌捲心菜，麵包捲，特殊醬",
        chicken_strips: "雞柳",
        chicken_strips_desc: "4塊調味辣炸雞柳",
        chicken_strips_ingredients:
          "4塊炸雞柳，120–150克薯條，100–120克涼拌捲心菜，麵包捲，鞑靼醬",
        fried_filet: "炸柳",
        fried_filet_desc: "🤩 2塊炸柳配特殊醬",
        fried_filet_ingredients:
          "2塊柳條，烤土豆，涼拌捲心菜，麵包捲，大蒜醬，泰國辣醬，辣椒醬",
        fried_mushroom_onion: "炸蘑菇和洋蔥",
        fried_mushroom_onion_desc: "🤩 炸蘑菇和洋蔥配鞑靼醬",
        fried_mushroom_onion_ingredients: "20塊炸蘑菇，6塊炸洋蔥圈，鞑靼醬",
        fried_wings: "炸雞翅",
        fried_wings_desc: "6塊炸雞翅 🍗",
        fried_wings_ingredients: "六個烤和炸雞翅",
        fried_chicken_basket: "炸雞籃",
        fried_chicken_basket_desc: "(2人份) 😍",
        fried_chicken_basket_ingredients:
          "2塊炸雞，2塊柳條，2塊洋蔥圈，2塊炸蝦塊，2塊雞塊",
        fried_schnitzel: "炸炸肉排",
        fried_schnitzel_desc: "四塊雞肉炸肉排 💥",
        fried_schnitzel_ingredients: "四個烤和炸調味雞肉炸肉排",
        veggie_basket_fried: "炸素籃",
        veggie_basket_fried_desc: "250克 🤩",
        veggie_basket_fried_ingredients: "250克，炸西葫蘆，茄子，蘑菇，土豆",
        fried_chicken_2_piece: "炸雞2塊",
        fried_chicken_2_piece_desc: "2塊炸雞 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150克薯條，100–120克涼拌捲心菜，麵包捲，特殊醬",
        fried_chicken_5_piece: "炸雞5塊",
        fried_chicken_5_piece_desc: "五塊炸雞",
        fried_chicken_5_piece_ingredients:
          "150–200克薯條，兩個涼拌捲心菜100–120克，兩個麵包捲，特殊醬",
        fried_chicken_7_piece: "炸雞7塊",
        fried_chicken_7_piece_desc: "七塊炸雞 💥",
        fried_chicken_7_piece_ingredients:
          "150–200克薯條，涼拌捲心菜100–120克，3個麵包捲，特殊醬，1人份炸醬",
        sandwich: "三明治",
        hotdog_sandwich: "熱狗三明治",
        hotdog_sandwich_desc: "熱狗三明治配蘑菇和奶酪",
        hotdog_sandwich_ingredients:
          "烤熱狗香腸，生菜，西紅柿，腌黃瓜，蘑菇和披薩奶酪",
        roast_beef_sandwich: "烤牛肉三明治",
        roast_beef_sandwich_desc: "✔️ 牛肉末",
        roast_beef_sandwich_ingredients:
          "牛肉，披薩奶酪，蘑菇，切片土豆脆片，生菜，西紅柿，腌黃瓜，特殊醬，法式麵包",
        ham_sandwich: "火腿三明治",
        ham_sandwich_desc: "雞火腿三明治配蘑菇（冷）",
        ham_sandwich_ingredients:
          "雞火腿配蘑菇，生菜，西紅柿，腌黃瓜，切片土豆脆片，特殊醬，法棍",
        bandari_sausage_sandwich: "班達里香腸三明治",
        bandari_sausage_sandwich_desc: "💥 辣班達里三明治",
        bandari_sausage_sandwich_ingredients:
          "班達里菜配煙燻雞尾酒香腸55%，西紅柿，腌黃瓜，特殊醬，洋蔥和香菜，大麵包",
        tongue_mushroom_sandwich: "舌頭蘑菇三明治",
        tongue_mushroom_sandwich_desc: "150克牛舌",
        tongue_mushroom_sandwich_ingredients:
          "蘑菇，巴氏殺菌披薩奶酪，橄欖，甜玉米，生菜，腌黃瓜，西紅柿，醬，配菜，薯條，涼拌捲心菜",
        falafel_sandwich: "沙拉三明治",
        falafel_sandwich_desc: "六個沙拉 🌭",
        falafel_sandwich_ingredients:
          "六個沙拉，腌黃瓜，西紅柿，生菜，1人份醬，配菜，薯條，涼拌捲心菜",
        cheesy_kebab_turki_sandwich: "奶酪土耳其烤肉三明治",
        cheesy_kebab_turki_sandwich_desc: "150克牛肉",
        cheesy_kebab_turki_sandwich_ingredients:
          "150克牛肉，特殊披薩奶酪，腌黃瓜，西紅柿，生菜，1人份醬，薯條，涼拌捲心菜",
        roast_chicken_sandwich: "烤雞三明治",
        roast_chicken_sandwich_desc: "雞肉炸肉排和蘑菇 🤩",
        roast_chicken_sandwich_ingredients:
          "雞肉炸肉排和蘑菇，特殊披薩奶酪，橄欖，甜玉米，芝麻，生菜，辣椒，腌黃瓜，西紅柿，特殊醬，配菜，薯條",
        cheesy_indian_sandwich: "印度奶酪三明治",
        cheesy_indian_sandwich_desc: "德國香腸 💥",
        cheesy_indian_sandwich_ingredients:
          "德國奶酪香腸，甜玉米，生菜，蘑菇，特殊醬，配菜，薯條，涼拌捲心菜",
        snack: "小吃",
        chicken_snack: "雞肉小吃",
        chicken_snack_desc: "😋 雞胸肉末",
        chicken_snack_ingredients:
          "150克雞胸，辣椒，蘑菇，特殊小吃麵包，特殊醬",
        meat_snack: "肉小吃",
        meat_snack_desc: "🥪 雙肉小吃",
        meat_snack_ingredients:
          "雙份，牛里脊肉末，莫扎里拉，甜玉米，辣椒，特殊醬，吐司麵包",
        chicken_meat_snack: "雞肉-肉小吃",
        chicken_meat_snack_desc: "🤩 雙雞肉-肉小吃",
        chicken_meat_snack_ingredients:
          "雙份，雞胸肉末，牛里脊肉末，莫扎里拉，甜玉米，辣椒，特殊醬，吐司麵包",
        special_snack: "特殊小吃",
        special_snack_desc: "🤤 雙特殊小吃",
        special_snack_ingredients:
          "雙份，卡爾巴斯混合牛肉和雞肉90%，莫扎里拉，甜玉米，辣椒，特殊醬，吐司麵包",
        roast_beef_snack: "烤牛肉小吃",
        roast_beef_snack_desc: "牛肉末 🍖",
        roast_beef_snack_ingredients:
          "牛肉末，蘑菇，披薩奶酪，辣椒，甜玉米，配菜，薯條，涼拌捲心菜",
        veggie_snack: "素食小吃",
        veggie_snack_desc: "4塊素食小吃",
        veggie_snack_ingredients:
          "西蘭花，甜玉米，橄欖，飲食披薩奶酪，蘑菇，配菜，薯條，涼拌捲心菜",
        chicken_mushroom_snack: "雞肉蘑菇小吃",
        chicken_mushroom_snack_desc: "雞肉炸肉排和蘑菇 👌",
        chicken_mushroom_snack_ingredients:
          "雞肉炸肉排，蘑菇，特殊披薩奶酪，橄欖，甜玉米，辣椒，配菜，薯條，涼拌捲心菜",
        pepperoni_snack: "佩珀羅尼小吃",
        pepperoni_snack_desc: "卡爾巴斯佩珀羅尼90% 💥",
        pepperoni_snack_ingredients:
          "雙份，卡爾巴斯佩珀羅尼90%，莫扎里拉，甜玉米，辣椒，特殊醬",
        bologna_snack: "博洛尼亞小吃",
        bologna_snack_desc: "牛肉末 👌",
        bologna_snack_ingredients:
          "雙份，牛肉末，特殊培根，漂白蘑菇，甜玉米，莫扎里拉，辣椒，特殊醬",
        pasta: "意大利麵",
        alfredo_pasta: "阿爾弗雷多意大利麵",
        alfredo_pasta_desc: "阿爾弗雷多意大利麵配特殊蘑菇醬",
        alfredo_pasta_ingredients: "350克通心粉",
        macaroni: "通心粉",
        macaroni_desc: "🥣 肉和蘑菇通心粉",
        macaroni_ingredients:
          "絲帶麵1,2，100克牛肉末，蘑菇，辣椒，烤土豆丁，豌豆",
        spaghetti_bolognese: "博洛尼亞意大利麵",
        spaghetti_bolognese_desc: "🥰 linguine麵",
        spaghetti_ingredients:
          "700克，linguine麵，牛肉和羊肉末，博洛尼亞醬，特殊紅Rasu醬，可選塑料勺叉",
        chicken_stroganoff: "雞肉斯特羅加諾夫",
        chicken_stroganoff_desc: "😍 雞肉斯特羅加諾夫配雞胸塊",
        chicken_stroganoff_ingredients:
          "180克調味雞胸塊，奶油，漂白蘑菇，帕爾馬乾酪，手-Cut薯條，特殊微波容器",
        penne_arrabbiata: "憤怒通心粉",
        penne_arrabbiata_desc: "雞胸 💥",
        penne_arrabbiata_ingredients:
          "1人份，雞胸，麵，蘑菇，帕爾馬乾酪，櫻桃西紅柿，歐芹，憤怒醬",
        chicken_pesto_pasta: "雞肉香草意大利麵",
        chicken_pesto_pasta_desc: "(1人份) 雞胸",
        chicken_pesto_pasta_ingredients:
          "雞胸，蘑菇，帕爾馬乾酪，櫻桃西紅柿，歐芹，憤怒醬",
        carbonara_pasta: "卡博納拉意大利麵",
        carbonara_pasta_desc: "牛肉培根97%",
        carbonara_pasta_ingredients:
          "麵，牛肉培根97%，阿爾弗雷多醬，帕爾馬乾酪，櫻桃西紅柿，歐芹",
        appetizer: "開胃菜",
        hot_chips: "熱薯片",
        hot_chips_desc: "😙 各種薯片口味",
        hot_chips_ingredients:
          "公斤薯片，特殊醬，雞火腿70%，蘑菇，辣椒，披薩奶酪，高達",
        lasagna: "千層麵",
        lasagna_desc: "牛肉末千層麵",
        lasagna_ingredients:
          "3張千層麵，牛肉末，蘑菇，辣椒，黑橄欖，披薩奶酪，特殊醬",
        french_fries: "薯條",
        french_fries_desc: "薯條配特製醬汁",
        french_fries_ingredients: "150克薯條，特製醬汁",
        baked_potato: "烤馬鈴薯",
        baked_potato_desc: "🍟烤馬鈴薯配牛肉培根",
        baked_potato_ingredients:
          "150克薯條，牛肉培根90%，披薩奶酪，特製香料，單人份醬汁",
        garlic_bread: "蒜香麵包",
        garlic_bread_desc: "特製蒜香醬💥",
        garlic_bread_ingredients:
          "美國披薩麵團，混合披薩奶酪，特製蒜香醬，芝麻",
        silo_potatoes: "西羅馬鈴薯",
        silo_potatoes_desc: "雙人份薯條",
        silo_potatoes_ingredients:
          "西羅香料薯條，牛肉培根97%，切達醬，蒜蓉蛋黃醬，蔥花，歐芹",
        bbq_sausage: "燒烤香腸",
        bbq_sausage_desc: "調味手指香腸🍢",
        bbq_sausage_ingredients:
          "500克調味馬鈴薯泥，200克調味手指香腸，洋蔥圈，綠橄欖，帕瑪森奶酪粉，櫻桃番茄，微型蔬菜，可烤奶酪，燒烤醬，辣味",
        silo_toast: "西羅吐司",
        silo_toast_desc: "160克牛里脊肉片🤩",
        silo_toast_ingredients:
          "160克牛里脊肉片，法國生菜，牛肉培根，農家麵包，燒烤醬，鞑靼醬，高粱，綠橄欖，微型蔬菜，蒜蓉蛋黃醬，帕瑪森奶酪粉",
        salad_and_dessert: "沙拉與甜點",
        caesar_salad: "凱薩沙拉",
        caesar_salad_desc: "單人份凱薩沙拉🥗",
        caesar_salad_ingredients:
          "混合生菜，烤雞，帕瑪森奶酪，蒜香麵包丁（蒜香麵包），凱薩醬，橄欖",
        caesar_salad_extra: "羅馬生菜，蒜香麵包丁，帕瑪森",
        coleslaw_salad: "高麗菜沙拉",
        coleslaw_salad_desc: "單人份高麗菜沙拉🍴",
        coleslaw_salad_ingredients: "手工製作，單人份，白高麗菜，玉米，醬汁",
        macaroni_salad: "通心粉沙拉",
        macaroni_salad_desc: "自家製火腿通心粉沙拉",
        macaroni_salad_ingredients: "通心粉，自家製火腿",
        pachira_salad: "帕奇拉沙拉",
        pachira_salad_desc: "雙人份帕奇拉沙拉🥗",
        pachira_salad_ingredients:
          "雙人份，混合生菜，牛肉培根脆片98%，焦糖核桃，帕瑪森奶酪，草莓，植物魚子醬，葡萄乾，檸檬片，玫瑰莓醬",
        greek_salad: "希臘沙拉",
        greek_salad_desc: "傳統希臘沙拉配羊奶酪與橄欖",
        greek_salad_ingredients: "羊奶酪，橄欖，黃瓜",
        tiramisu: "提拉米蘇",
        tiramisu_desc: "經典義大利提拉米蘇甜點",
        tiramisu_ingredients: "咖啡，馬斯卡彭奶酪，可可粉",
        beverages: "飲料",
        local_yogurt_drink: "當地優格飲料",
        local_yogurt_drink_desc: "家庭式當地優格飲料🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "黑汽水",
        black_soda_desc: "杯裝黑汽水🧋",
        black_soda_ingredients: "",
        fanta: "黃汽水",
        fanta_desc: "杯裝黃汽水🥤",
        fanta_ingredients: "",
        mojito: "莫希托",
        mojito_desc: "杯裝莫希托，容量350至400毫升🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "熱帶麥芽飲料",
        tropical_malt_beverage_desc: "杯裝熱帶麥芽飲料🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "地址",
        address_text: "請輸入目標網站連結",
        instagram_label: "Instagram",
        instagram_text: "請輸入您的用戶名稱",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "影片畫廊",
        description: "為更了解QR-Land智能系統服務，請觀看以下影片。",
        tutorial: "教學",
        fast_food: "速食",
      },
      feedback: {
        title: "您的回饋",
        description: "請透過回答以下問題，協助我們提供更好的服務",
        question1: "您對我們的服務與食物品質滿意度如何？",
        question2: "您如何評價餐廳的菜色多樣性？",
        question3: "您如何評價餐廳員工的服務態度？",
        question4: "食物是否準時送達？",
        question5: "您是否有任何改進服務或食物品質的建議？",
      },
      worksheet: {
        saturday: "星期六",
        sunday: "星期日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        shift_1_saturday: "10:00 至 22:00",
        shift_1_sunday: "10:00 至 22:00",
        shift_1_monday: "10:00 至 22:00",
        shift_1_tuesday: "10:00 至 22:00",
        shift_1_wednesday: "10:00 至 00:00",
        shift_1_thursday: "10:00 至 00:00",
        shift_1_friday: "10:00 至 00:00",
      },
      gallery: {
        gallery_0: "圖庫0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "烤馬鈴薯 2",
        chicken_stroganoff_1: "雞肉斯特羅加諾夫1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location: "德黑蘭，謝里亞提街，賽義德·漢丹橋後，漢丹死巷，6號，3單元",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "伊朗，德黑蘭，德黑蘭市，德黑蘭，德黑蘭市3區，賽義德·漢丹社區，阿里·謝里亞提博士，漢丹",
      },
    },
    messages: {
      qr_created_success: "線上菜單已成功建立。",
      qr_updated_success: "您的線上菜單QR已成功編輯。",
      qr_create_error: "建立QR時發生錯誤！",
      qr_update_error: "儲存/編輯QR時發生錯誤",
      template_categories_saved: "範例模型的分類已成功儲存。",
      template_products_saved: "範例模型的產品已成功儲存。",
      template_categories_error: "儲存範例模型分類時發生錯誤！",
      template_products_error: "儲存範例模型產品時發生錯誤！",
    },
    sample_menu: "範例菜單",
    view_qr: "檢視QR",
    preview: "預覽",
    download_qr: "下載QR",
    create_qr: "建立QR",
    online_menu_name: "線上菜單名稱",
    online_menu_name_short: "菜單名稱",
    enter_qr_address: "請輸入QR地址",
    qr_address: "QR地址",
    enter_menu_information: "請輸入菜單資訊",
    cleardefaults: "清除預設值",
    select_sample_menu: "選擇範例菜單",
    select_ready_menu: "選擇現成菜單",
    online_sales: "線上銷售",
    sales_settings: "銷售設定",
    download: "下載",
    gallery_photos: "圖庫照片",
    fast_food_1: "速食圖片 1",
    fast_food_2: "速食圖片 2",
    large_chain_fast_food: "大型連鎖速食",
    best_fast_food_taste_experience: "與我們一同體驗最佳速食風味",
    online_menu_created_successfully: "線上菜單已成功建立。",
    qr_creation_failed: "建立QR時發生錯誤！",
    online_menu_qr_updated_successfully: "您的線上菜單QR已成功編輯。",
    error_saving_updating_qr: "儲存/編輯QR時發生錯誤",
    sample_model_categories_saved_successfully: "範例模型的分類已成功儲存。",
    sample_model_products_saved_successfully: "範例模型的產品已成功儲存。",
    error_saving_sample_model_products: "儲存範例模型產品時發生錯誤！",
    error_saving_sample_model_categories: "儲存範例模型分類時發生錯誤！",
  },
  editMenu: {
    enter_menu_information: "請輸入菜單資訊",
    online_menu_name: "線上菜單名稱",
    online_menu_name_short: "線上菜單簡稱",
    fields: {
      qr_address_hint: "用於存取線上菜單的QR地址",
    },
    online_sales: "線上銷售",
    sales_settings: "銷售設定",
    shop: {
      upload_banner: "上傳橫幅",
      create_product: "建立產品",
      user_info: "使用者資訊",
      add_social_media: "新增社群媒體",
      photo_gallery: "圖片畫廊",
      video_gallery: "影片畫廊",
      feedback: "回饋",
      working_hours: "營業時間",
    },
    success_message: "您的名片已成功編輯。",
  },
  qrCodeSquare: {
    dots_color: "點點顏色",
    gradient_color: "漸層色彩",
    linear: "線性",
    radial: "放射狀",
    color_rotation: "顏色旋轉",
    first_color: "第一種顏色",
    second_color: "第二種顏色",
    dots_color_label: "點點顏色",
  },
  language: {
    selectAll: "全選",
    lang: {
      fa: "波斯語",
      ar: "阿拉伯語",
      ar_ae: "阿拉伯語 (阿聯酋)",
      ar_iq: "阿拉伯語 (伊拉克)",
      en_US: "英語 (美國)",
      en_GB: "英語 (英國)",
      de: "德語",
      fr: "法語",
      zh_CN: "簡體中文",
      zh_TW: "繁體中文",
      tr: "土耳其語",
      ru: "俄語",
      hy: "亞美尼亞語",
    },
    only_manual_now: "目前僅支援手動翻譯",
    ai_coming_soon: "AI 翻譯即將上線",
    got_it: "知道了",
    origin_language: "來源語言",
    target_languages: "目標語言",
    remove_all: "移除所有語言",
    translation_method: "選擇翻譯方式",
    manual_translation: "手動翻譯",
    ai_translation: "AI 翻譯",
    coming_soon: "即將推出",
    source_language_updated: "來源語言已更新",
    error_changing_source_language: "更改來源語言時出錯",
    source_language_created: "已建立新來源語言",
    languages_saved: "新語言已儲存",
    error_saving_languages: "儲存語言時出錯",
    error_loading_language: "載入語言時出錯",
    languages_removed: "已移除的語言",
    new_languages_to_save: "待儲存的新語言",
    saved: "已儲存",
    management_langs: "語言管理",
    add_langs: "新增語言",
    change_language: "更改語言",
    visit_card: "名片",
    translate_to: "翻譯為",
    main_language: "主要語言",
    no_languages_available: "無可用語言",
    return_to_default: "返回預設語言",
    translate: "翻譯",
    changes_pending: "等待應用更改",
    apply_changes: "套用變更",
    cancel_changes: "取消",
  },
  winner_list: "中獎名單",
  qrwinnersList: {
    winnerstotalcount: "QR 總獲獎人數",
    winnerscountoffilter: "套用篩選後的獲獎人數",
    winnersList: "QR中獎名單",
    prize: "獎品",
    winnerName: "中獎人姓名",
    date: "日期",
    noWinners: "暫無中獎記錄",
    perPage: "每頁顯示數量",
    search: "按中獎人或獎品搜尋",
    sortDirection: "排序方向",
    sortBy: "排序依據",
  },
  appearance_settings: "外觀設定",
  header_color: "標頭顏色",
  background_color: "背景顏色",
  text_color: "文字顏色",
  font_size: "字體大小",
  chat_logo: "聊天標誌",
  floating_button_icon: "浮動按鈕圖示",
  assistant_name: "助手名稱",
  chat_preview: "聊天預覽",
  smart_assistant: "智能助手",
  online: "線上",
  aiChatSettings: {
    select_assistant: "選擇助手",
    appearance_settings: "外觀設定",
    lead_connection_tab: "領取線索 - 連接客戶俱樂部",

    header_settings: "標頭設定",
    header_settings_desc: "聊天標頭顏色與樣式",
    text_settings: "文字設定",
    text_settings_desc: "字體顏色與大小",
    logo_settings: "標誌設定",
    logo_settings_desc: "助手照片或圖示",
    background_settings: "背景設定",
    background_settings_desc: "背景圖片或顏色",

    gradient_color: "漸層顏色",
    solid_color: "純色",
    use_image: "使用圖片",
    use_icon: "使用圖示",

    first_color: "第一種顏色",
    second_color: "第二種顏色",
    header_color: "標頭顏色",
    text_color: "文字顏色",
    background_color: "背景顏色",

    font_size: "字體大小",

    robot: "機器人",
    chat: "聊天",
    support: "支援",
    question: "問題",
    message: "訊息",
    assistant_voice: "助手",
    ai_brain: "人工智慧",

    lead_connection_title: "連接客戶俱樂部",
    lead_alert:
      "設定這些選項後，當使用者選擇提交線索時，其資訊將被儲存在客戶俱樂部中。",

    hasAssistantsName_label: "取得姓名",
    hasAssistantsName_hint: "收集使用者姓名",
    hasAssistantsFamily_label: "取得姓氏",
    hasAssistantsFamily_hint: "收集使用者姓氏",
    hasAssistantsMobile_label: "取得手機號碼",
    hasAssistantsMobile_hint: "收集使用者手機號碼",
  },
  assistantChatViewer: {
    assistant_name: "智能助手",
    online: "在線",
    new_chat: "新對話",
    clear_chat: "清除對話",
    close: "關閉",
    message_placeholder: "訊息...",
    processing: "處理中...",
    renew: "續訂",
    created_at: "建立時間",
    last_edit: "最後編輯",
    copied: "已複製",
    copy: "複製",
    print_qr: "列印二維碼",
    print_visit_card: "列印名片",
    send_link: "傳送連結",
    winner_list: "得獎名單",
    customer_list: "客戶列表",
    order_list: "訂單列表",
    reserved_appointments: "預約記錄",
    feedback: "回饋",
    request_form: "請求表單",
    transfer_ownership: "轉讓所有權",
    store_management: "商店管理",
    select_nfc_card: "選擇NFC卡",
    edit: "編輯",
    design: "設計",
    qr_settings: "二維碼設定",
    deactivate: "停用",
    download: "下載",
    viewed: "次瀏覽",
    see_more: "查看更多",
    updating_qr: "正在更新二維碼...",
  },
  create_game: "建立遊戲",
  ready_games: "現成遊戲",
  add_game: "新增遊戲",
  game_gallery: "遊戲圖庫",
  game_size_error: "遊戲檔案大小不得超過 2MB",
  game_upload_error: "遊戲上傳錯誤",
  no_game_available: "無可用遊戲",
  to_use_ready_games_search_category_or_product:
    "使用現成遊戲，請依分類或產品搜尋",
  gif_size_error: "GIF 檔案大小不得超過 2MB",
  previewer_page: "預覽顯示",
  // ─────────────────────────────────────────────────────
  // 遊戲、GIF 和設定區塊的翻譯鍵值
  // 檔案：src/core/services/langs/zh_TW.js
  // 語言：繁體中文（Traditional Chinese，適合台灣/香港）
  // ─────────────────────────────────────────────────────
  // 1. 主要遊戲編輯器 (PublicGameEditor)
  game_editor: "遊戲編輯器",
  reset_defaults: "重置為預設值",
  save_and_preview: "儲存並預覽",
  texts: "文字",
  images: "圖像",
  colors: "顏色",
  general_settings: "一般設定",
  gameplay_settings: "遊戲玩法設定",
  effects: "效果",
  login_and_phone: "登入與電話號碼",
  no_settings_available_for_this_game_type: "此遊戲類型無可用設定",
  confirm_reset: "確認重置",
  reset_all_settings_to_default: "您確定要將所有設定重置為預設值嗎？",
  yes_reset: "是，重置",
  cancel: "取消",
  settings_reset_successfully: "設定已成功重置",
  saved_and_ready_for_preview: "已儲存並準備預覽",

  // 2. 登入與電話標籤 (TabLogin)
  login_and_phone_settings: "登入與電話號碼設定",
  ask_phone_after_game: "遊戲結束後要求電話號碼",
  phone_prompt_text: "電話號碼提示文字",
  phone_prompt_hint: "電話號碼請求對話框中顯示的文字",
  submit_button: "提交按鈕",
  login_dialog_logo: "登入對話框標誌",
  logo_url: "標誌 URL",

  // 3. 效果標籤 (TabEffect)
  game_effects_settings: "遊戲效果設定",
  sound_enabled: "啟用音效",
  volume: "音量",
  volume_hint: "遊戲音量等級（0 至 1）",
  oscillator_type: "振盪器類型",
  jump_sound_freq: "跳躍音效頻率",
  hit_sound_freq: "碰撞音效頻率",
  powerup_sound_freq: "強化道具音效頻率",
  move_sound_freq: "移動音效頻率",
  combo_base_freq: "連擊基礎頻率",
  sound_durations: "音效持續時間",
  move_duration_ms: "移動音效持續時間（毫秒）",
  jump_duration_ms: "跳躍音效持續時間（毫秒）",
  combo_duration_ms: "連擊音效持續時間（毫秒）",
  hit_duration_ms: "碰撞音效持續時間（毫秒）",
  vibration_enabled: "啟用震動",
  particles_enabled: "啟用粒子效果",
  explosion_settings: "爆炸粒子設定",
  particle_count: "粒子數量",
  gravity: "重力",
  friction: "摩擦力",
  fade_speed: "淡出速度",

  // 4. 圖像標籤 (TabImages)
  game_images_and_assets: "遊戲圖像與資源",
  player_image: "玩家圖像",
  player: "玩家",
  powerup_image: "強化道具圖像",
  qr_powerup: "QR 強化道具",
  enemy_images: "敵人圖像",
  optional_multi: "選填，多張圖像",
  enemies: "敵人",
  background_image: "背景圖像",
  background: "背景",
  phone_frame_background: "手機框架背景",
  phone_frame: "手機框架",
  winner_background: "勝利者背景",
  winner: "勝利者",
  ground_image: "地面圖像",
  ground: "地面",
  player_character: "玩家角色",
  far_background_layer: "遠景背景圖層",
  background_far: "遠景背景",
  near_background_layer: "近景背景圖層",
  background_near: "近景背景",
  obstacle_images: "障礙物圖像",
  multi_optional: "多張圖像，選填",
  obstacles: "障礙物",

  // 5. 文字標籤 (TabTexts)
  game_text_contents: "遊戲文字內容",
  main_screen_texts: "主畫面文字",
  game_title: "遊戲標題",
  game_subtitle: "遊戲副標題",
  start_button: "開始按鈕",
  score_label: "分數標籤",
  game_over_screen: "遊戲結束畫面",
  game_over_title: "遊戲結束標題",
  game_over_subtitle: "遊戲結束副標題",
  phone_prompt: "電話號碼請求",
  restart_button: "重新開始按鈕",
  hud_and_labels: "抬頭顯示與標籤",
  level_label: "關卡標籤",
  combo_label: "連擊標籤",
  final_score_label: "最終分數標籤",
  high_score_label: "最高分標籤",
  messages_and_popups: "訊息與彈出視窗",
  new_record_message: "新紀錄訊息",
  fun_random_messages: "趣味隨機訊息",
  add_new_message: "新增訊息",

  // 6. 一般設定標籤 (TabSetting)
  general_game_settings: "遊戲一般設定",
  enemy_spawn_rate: "敵人生成速率",
  frames_between_enemies_spawn: "敵人間隔幀數",
  powerup_spawn_rate: "強化道具生成速率",
  frames_between_qr_spawn: "QR 間隔幀數",
  win_score_threshold: "勝利分數門檻",
  score_required_for_win_or_phone_prompt: "勝利或顯示電話提示所需分數",
  starting_lives: "初始生命數",
  high_score_storage_key: "最高分儲存鍵值",
  phone_prompt_score_threshold: "電話提示分數門檻",
  score_to_show_phone_number_form: "顯示電話號碼表單的分數",
  no_general_settings_available_for_this_game: "此遊戲無一般設定",

  // 7. 遊戲玩法標籤 (TabGamePlay)
  speed_settings: "速度設定",
  initial_speed: "初始速度",
  max_speed: "最大速度",
  speed_increase_every_frames: "每 X 幀增加速度",
  speed_increase_amount: "速度增加量",
  distance_per_level: "每關距離",
  level_speed_increase: "每關速度增加",
  jump_and_physics: "跳躍與物理",
  jump_force: "跳躍力",
  max_jump_height: "最大跳躍高度",
  lanes_settings: "車道設定",
  number_of_lanes: "車道數量",
  starting_lane: "起始車道",
  enemies_spawn: "敵人生成",
  traps_spawn: "陷阱生成",
  min_spawn_interval_ms: "最小生成間隔（毫秒）",
  max_spawn_interval_ms: "最大生成間隔（毫秒）",
  same_lane_chance: "相同車道機率",
  probability_of_spawn_in_player_lane: "在玩家車道生成的機率",
  collision_tolerance_px: "碰撞容忍度（像素）",
  scoring_rules: "計分規則",
  hit_penalty: "碰撞懲罰",
  powerup_reward: "強化道具獎勵",
  score_speed_divider: "分數速度除數",
  reset_combo_on_hit: "碰撞時重置連擊",
  camera_settings: "攝影機設定",
  normal_zoom: "正常縮放",
  hit_zoom: "碰撞時縮放",
  zoom_lerp_speed: "縮放過渡速度",
  game_end_conditions: "遊戲結束條件",
  phone_dialog_score_threshold: "電話對話框分數門檻",

  // 8. 顏色標籤 (TabColors)
  background_gradient: "背景漸層",
  first_color: "第一顏色",
  second_color: "第二顏色",
  particle_hit_color: "碰撞粒子顏色",
  particle_powerup_color: "強化道具粒子顏色",
  main_background_color: "主要背景顏色",
  ground_color: "地面顏色",
  hud_colors: "HUD 顏色",
  hud_background: "HUD 背景",
  score_text_color: "分數文字顏色",
  level_text_color: "關卡文字顏色",
  combo_text_color: "連擊文字顏色",
  overlay_colors: "疊加層顏色",
  backdrop_color: "背景幕顏色",
  card_background: "卡片背景",
  card_border_color: "卡片邊框顏色",
  explosion_particle_color: "爆炸粒子顏色",

  // 9. QR 預覽元件 (previewerQr)
  gif_tab: "GIF 標籤",
  game_tab: "遊戲標籤",
  welcome_gif_upload: "上傳歡迎 GIF",
  default_welcome: "預設歡迎",
  loading_animation: "載入動畫",
  hide_previewer: "隱藏預覽",
  show_previewer: "顯示預覽",
  edit_game_settings: "編輯遊戲設定",
  save_and_close: "儲存並關閉",
  animation_scale: "動畫縮放",
  animation_slide_x: "水平滑動動畫",
  animation_slide_y: "垂直滑動動畫",
  animation_fade: "淡入淡出動畫",
  game_settings_saved: "遊戲設定已儲存",
  no_game_configured: "尚未設定遊戲",

  // 10. GIF 選擇器 (gifSelector)
  gallery_name: "圖庫名稱",
  change_gallery_name: "變更圖庫名稱",
  add_gif: "新增 GIF",
  select_gif: "選擇 GIF",
  show_gif: "顯示 GIF",
  selected_gif: "已選擇 GIF",
  count: "數量",
  select_category: "選擇分類",
  after_typing_enter: "輸入後按 Enter",
  search: "搜尋",
  no_gif_available: "無可用 GIF",
  to_use_ready_gifs_search_category_or_product:
    "使用現成 GIF，請依分類或產品搜尋",
  max_file_size_2mb: "檔案大小上限 2MB",
  upload_file: "上傳檔案",
  drag_and_drop_to_upload_or: "拖曳上傳或",
  here: "這裡",
  click: "點擊",
  all: "全部",
  no_gif_found: "未找到 GIF",
  for_adding_file_use_upload_center: "新增檔案請使用上傳中心",
  to_use_external_gif_link_fill_fields: "使用外部 GIF 連結，請填寫欄位",
  gif_url_hint: "GIF 檔案完整網址",
  gif_url: "GIF 網址",
  add: "新增",
  title: "標題",
  link: "連結",
  description: "描述",
  add_new_gallery: "新增圖庫",
  enter_valid_link: "輸入有效連結",
  create_gif: "建立 GIF",
  ready_gifs: "現成 GIF",
  gif_gallery: "GIF 圖庫",
  edit_gif: "編輯 GIF",
  max_background_gif_size_2mb: "背景 GIF 大小上限 2MB",
  uploaded_successfully: "上傳成功",
  gif_upload_error: "GIF 上傳錯誤",

  // 11. 額外文字與測試鍵值
  preview: "預覽",
  start_button_text: "開始按鈕文字",
  game_over_text: "遊戲結束文字",
  game_over_subtext: "遊戲結束副文字",
  mobile_prompt_text: "手機提示文字",
  submit_button_text: "提交按鈕文字",
  optional: "選填",
  game_background: "遊戲背景",
  background_gradient_colors: "背景漸層顏色",
  frames_per_enemy: "每敵人幀數",
  frames_per_powerup: "每強化道具幀數",
  win_threshold: "勝利門檻",
  score_to_win: "勝利所需分數",
  your_work_page_name: "個人/公司 Kiwvar",
  "pdf_gallery": {
    "display_mode": "PDF畫廊顯示模式",
    "display_mode_label": "顯示模式",
    "layout": {
      "list": "列表視圖",
      "accordion": "手風琴視圖",
      "slider": "滑塊視圖"
    },
    "gallery_name": "畫廊名稱",
    "selected_gallery": "選定的畫廊",
    "add_file": "添加文件",
    "pdf_gallery_label": "PDF畫廊",
    "select_file": "選擇文件",
    "title": "標題",
    "pdf_url": "PDF網址",
    "description": "描述",
    "add_button": "添加",
    "all": "全部",
    "image_gallery": "圖片畫廊",
    "edit_pdf": "編輯PDF",
    "preview": "預覽",
    "add_pdf_gallery": "添加PDF畫廊",
    "default_gallery_name": "畫廊",
    "gallery_prefix": "畫廊",
    "tabs": {
      "add_file": "添加文件",
      "pdf_gallery": "PDF畫廊",
      "link": "鏈接"
    },
    "messages": {
      "file_too_large": "文件大小不能超過10 MB。",
      "invalid_file_type": "請僅選擇文檔和文本文件。",
      "upload_error": "上傳文件時出錯。",
      "only_pdf_txt_allowed": "只能添加PDF和TXT文件。",
      "title_url_required": "請輸入標題和文件網址。"
    }
  },
  "special_info_desc": {
    "textCards": "添加文本卡片以顯示用戶信息，如描述、背景或簡短的個人簡介。",
    "customerClubSettings": "設置在用戶註冊其號碼後發送的客戶俱樂部會員消息。",
    "advanceSettings": "管理高級和智能設置以自定義頁面行為和功能。",
    "voiceGallery": "上傳和管理在頁面上播放的音頻文件。",
    "VideoGallery": "添加並顯示用於介紹、培訓或內容展示的視頻。",
    "imageUploader": "上傳要在畫廊或頁面的不同部分中顯示的圖片。",
    "colorPallete": "選擇自定義顏色以個性化頁面設計和外觀。",
    "socialMediaIcons": "添加社交媒體鏈接以便用戶快速訪問。",
    "pdfSelector": "上傳並顯示PDF文件供用戶查看或下載。",
    "FeedBack": "接收用戶關於服務或內容的評論和反饋。",
    "consultationNew": "創建一個表單，供用戶提交請求、獲取諮詢或聯繫。"
  },
  "voice_gallery": {
    "autoplay_warning": "您一次只能設置一個音頻文件自動播放。",
    "autoplay": "自動播放"
  },
  "card": {
    "consultation": {
      "title": "請求表單"
    },
    "form": {
      "name": "名字",
      "surname": "姓氏",
      "phone": "手機號碼",
      "email": "電子郵件",
      "address": "地址",
      "national_id": "身份證號",
      "location": "位置",
      "description": "描述"
    },
    "feedback": {
      "title": "您的反饋",
      "description": "請回答以下問題，幫助我們改進服務：",
      "q1": "您對QRLand服務有多滿意？",
      "q2": "QRLand服務在多大程度上滿足了您的需求？",
      "q3": "為所獲服務支付的費用合理度如何？",
      "q4": "與我們分享您的想法以改善我們的服務。"
    },
    "pdf": {
      "gallery_name": "QRLand提案畫廊",
      "item1_title": "產品介紹提案",
      "item1_desc": "全面介紹QRLand服務，智能QR碼的工作原理，對企業的好處以及用例。",
      "item2_title": "數字名片提案",
      "item2_desc": "介紹QRLand數字名片，快速分享聯繫信息，社交媒體鏈接和CRM的功能。"
    },
    "pdf_selector": {
      "title": "PDF畫廊",
      "description": "描述"
    },
    "info": {
      "visit_name": "QRLand / 數字名片",
      "organization_name": "QRLand",
      "sub_organ": "首個動態QR生成器平台",
      "user_name": "數字名片",
      "fax": "傳真：02191016066",
      "location_desc": "德黑蘭，Shariati街，Seyed Khandan橋後，Khandan巷，6號",
      "postal_code": "郵政編碼：1541946815",
      "about_us": "由於實體名片存在的問題，QRLand平台推出了一款名為“數字名片”的產品。利用數字技術，它徹底消除了實體名片的局限性，同時通過使用智能替代品，防止過度砍伐樹木。",
      "full_address": "伊朗，德黑蘭省，德黑蘭，第3區，Seyed Khandan社區，Dr. Ali Shariati，Khandan"
    },
    "extra": {
      "field1": "🟥 為您自己的企業創建一張類似的數字名片。\n🟧 免費測試3天。\n🟨 點擊這裡免費註冊。",
      "field2": "您的數字名片具有動態QR碼。您可以隨時通過手機編輯信息。編輯後，您的QR碼永遠不會改變。",
      "field3": "💲 擁有此名片的費用為90萬土曼。"
    },
    "gallery": {
      "name": "我們將永遠站在您身邊..."
    },
    "social": {
      "address_hint": "請輸入您的地址",
      "address_label": "地址",
      "instagram_hint": "請輸入您的Instagram網址",
      "instagram_label": "Instagram",
      "whatsapp_hint": "請輸入您的WhatsApp網址",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "為什麼選擇QRLand名片？QRLand有什麼不同？",
      "item1_title": "為什麼選擇QRLand名片",
      "item2_name": "QRLand數字名片介紹",
      "item2_title": "實體名片的最佳替代品"
    },
    "club": {
      "title": "客戶俱樂部會員",
      "description": "這不是一個普通的客戶俱樂部！\n註冊您的號碼"
    },
    "audio": {
      "category_all": "全部",
      "item1_title": "數字名片綜合指南",
      "diff_seconds": "1秒前"
    }
  },
  "pic": {
    "background_image": "背景圖片",
    "image_display_type": "圖片顯示類型",
    "image_orientation": "圖片方向：",
    "horizontal": "水平",
    "vertical": "垂直",
    "change_display_mode": "更改顯示模式",
    "image": "圖片",
    "uploaded_image": "上傳的圖片"
  },
   "send_limit_per_user": "每位用戶發送限制 (0 = 不限)",
    "enable_discount_code": "啟用折扣碼",
    "add_new_discount_code": "添加新折扣碼",
    "no_discount_codes_added": "尚未添加折扣碼",
"toolsManagment": "管理工具",
"gateway": {
  "edit": "編輯",
  "integrated_edit_all_sections": "所有部分的一體化編輯",
  "show_descriptions": "顯示描述",
  "search_section_placeholder": "搜尋部門...",
  "no_section_found": "未找到以此命名的部門。",
  "back_to_menu": "返回選單",
  "cancel": "取消",
  "save": "儲存"
},
"gridShow": "網格檢視",
"tableShow": "表格檢視",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "新增文字卡片，用於顯示使用者資訊，例如描述、經歷或簡短介紹。",

    customer_club_settings_description:
      "設定客戶俱樂部入會訊息，使用者註冊手機號碼後將收到此訊息。",

    advance_settings_description:
      "管理進階與智慧設定，以個人化頁面的行為與功能。",

    voice_gallery_description:
      "上傳及管理可在頁面上播放的音訊檔案。",

    video_gallery_description:
      "新增並顯示用於介紹、教學或內容展示的影片。",

    image_uploader_description:
      "上傳圖片，用於在圖庫或頁面的不同區域中顯示。",

    color_palette_description:
      "選擇自訂色彩，以個人化頁面的外觀與設計。",

    social_media_icons_description:
      "新增社群媒體連結，方便使用者快速存取。",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "上傳或變更商場的主要橫幅圖片。",

    logo_select_description:
      "設定企業或商場的標誌。",

    service_description:
      "管理商場的主要服務與設施。",

    faq_description:
      "新增及編輯客戶常見問題。",

    blog_description:
      "新增與商場相關的文章與新聞。",

    floor_description:
      "管理商場的樓層與商店單位。",

    text_cards_description:
      "輸入描述及使用者相關資訊。",

    social_media_icons_description:
      "新增社群媒體連結，方便客戶聯絡。",

    pic_selector_description:
      "新增商場及商店的圖片。",

    video_gallery_description:
      "上傳介紹影片或宣傳影片。",

    pdf_selector_description:
      "管理型錄及資訊指南檔案。",

    feedback_description:
      "管理訪客意見與回饋區域。",

    consultation_new_description:
      "管理用於收集客戶資訊或需求的表單。",

    service_section_description:
      "建立專屬服務區域。",

    counter_service_description:
      "以數字形式顯示商場的統計資料與成就。",

    counter_description:
      "設定活動或開幕倒數計時。",

    personnel_description:
      "介紹管理人員與核心團隊成員。",

    customer_club_settings_description:
      "管理簡訊及客戶俱樂部註冊設定。",

    work_sheet_description:
      "設定商場的營業時間與營業日。",

    pallet_commercial_description:
      "設定頁面的色彩與視覺風格。",

    default_description:
      "在企業頁面中新增及管理 {title} 區域。",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "設定登入頁面並變更商店標誌。",

  banner_selector_description:
    "上傳及管理商店橫幅。",

  text_cards_description:
    "文字資訊、商店介紹及關於我們。",

  product_description:
    "建立、管理及編輯商品。",

  special_category_manager_description:
    "管理特別優惠及折扣商品的分類。",

  social_media_icons_description:
    "新增商店的社群媒體連結。",

  blog_description:
    "撰寫及管理部落格文章。",

  service_description:
    "介紹所提供的額外服務。",

  faq_description:
    "顯示及管理常見問題清單。",

  pic_selector_description:
    "上傳及管理商店圖片圖庫。",

  video_gallery_description:
    "上傳介紹影片及宣傳影片。",

  pdf_selector_description:
    "提供指南檔案或 PDF 型錄。",

  feedback_description:
    "管理客戶評論與回饋。",

  counter_description:
    "設定活動或特別優惠的倒數計時。",

  consultation_description:
    "建立用於接收需求或諮詢申請的表單。",

  service_section_description:
    "管理專屬服務區域。",

  counter_service_description:
    "顯示商店的統計資料、數據及成就。",

  personnel_description:
    "介紹團隊成員及商店工作人員。",

  work_sheet_description:
    "設定商店的營業日期與工作時間。",

  default_description:
    "在商店頁面中新增及管理 {title} 區域。",
},
edit_gold_special_info_single: {
  product_info_title: "產品資訊",
  product_info_description:
    "新增及編輯產品的基本資訊、特色、價格與補充說明。",

  asset_management_title: "資產管理",
  asset_management_description:
    "管理資產、配置價值以及與產品相關的錢包資訊。",

  add_social_networks_title: "新增社群網路",
  social_networks_title: "社群網路",
  social_media_description:
    "新增社群媒體連結，讓客戶更快速地與您的品牌聯絡。",

  add_video_title: "新增影片",
  video_description:
    "新增並顯示產品介紹、教學或宣傳影片。",

  add_image_title: "新增圖片",
  image_description:
    "上傳不同角度的高品質產品圖片，以便在圖庫中更好地展示產品。",

  select_color_title: "選擇顏色",
  color_palette_description:
    "依照您的品牌識別自訂產品展示頁面的配色與外觀。",
},

edit_multicard_special_info_single: {
  add_account_description:
    "編輯名稱、個人頭像與背景",

  management_account_description:
    "新增及編輯銀行帳戶資訊",

  management_color_description:
    "變更按鈕與背景的色彩主題",
},

edit_feedback_special_single: {
  base_info_description:
    "編輯基本資訊與表單標題",

  image_uploader_description:
    "上傳及管理回饋表單的標誌",

  feedback_description:
    "設定欄位並管理回饋表單",

  color_palette_description:
    "選擇色彩主題並自訂表單外觀",
},

edit_gitf_special_info_single: {
  default_description:
    "在回憶 QR 相框中新增及管理 {title} 區域。",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "型錄的基本資訊、標題與描述",

  image_uploader_description:
    "上傳及管理標誌或主要圖片",

  pic_selector_description:
    "上傳及管理型錄或手冊頁面",

  social_media_icons_description:
    "新增及管理社群媒體連結",

  color_palette_description:
    "選擇色彩主題並自訂外觀",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "選擇範本以套用不同的分類方式",

  login_config_description:
    "登入頁面設定與外觀",

  general_settings_description:
    "貨幣與商業類型的一般設定。",

  banner_selector_description:
    "上傳並選擇顯示於頁面頂部的橫幅圖片，讓選單或個人資料的外觀更加吸引人。",

  product_description:
    "建立及管理產品或服務，包括圖片、價格與自訂描述等詳細資訊。",

  text_cards_description:
    "新增文字卡片，用於顯示使用者基本資訊，例如一般描述、經歷或簡短介紹。",

  social_media_description:
    "新增社群媒體連結與圖示，讓客戶能更快速聯絡及存取。",

  photo_gallery_description:
    "建立圖片圖庫，用於展示產品照片、作品集或商業環境。",

  video_gallery_description:
    "新增影片圖庫，用於展示宣傳影片、教學影片或介紹影片。",

  feedback_description:
    "建立區域以展示客戶評論、回饋及過往客戶的滿意度。",

  working_hours_description:
    "設定工作時間與營業時間。",
},

edit_pdf_special_info_single: {
  base_info_title: "資訊",
  base_info_description:
    "新增文字卡片，用於顯示使用者基本資訊，例如一般描述、經歷或簡短介紹。",

  image_uploader_title: "上傳標誌",
  image_uploader_description:
    "上傳並選擇圖片作為標誌或個人頭像，顯示於頁面上。",

  pdf_selector_title: "新增 PDF 圖庫",
  pdf_selector_description:
    "建立 PDF 或文字檔案圖庫，並可為每個檔案新增封面圖片與自訂描述。",

  social_media_icons_title: "新增社群網路",
  social_media_icons_description:
    "新增社群媒體連結與圖示，以便更快速聯絡與存取。",

  color_palette_title: "選擇顏色",
  color_palette_description:
    "選擇範本顏色並自訂元素外觀，使其更符合您的品牌。",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "在照片圖庫中新增及管理 {title} 區域。",
},

edi_social_special_info_single: {
  banner_selector_title: "上傳照片",
  banner_selector_description:
    "選擇並上傳社群媒體頁面頂部的背景圖片或橫幅。",

  base_info_title: "資訊",
  base_info_description:
    "輸入主要標題與個人資料描述等基本資訊。",

  image_uploader_title: "上傳標誌",
  image_uploader_description:
    "上傳個人標誌、品牌標誌或個人頭像，以便顯示於頁面上。",

  social_media_icons_title: "新增社群網路",
  social_media_icons_description:
    "新增 Instagram、Telegram、WhatsApp、LinkedIn 及其他社群網路的連結，讓其圖示顯示於頁面上。",
},

edit_text_special_info_single: {
  base_info_title: "QR 資訊與文字",
  base_info_subtitle: "主要文字與文字欄位",
  base_info_description:
    "編輯標題、關於我們的主要文字以及自訂 QR 文字欄位",

  image_uploader_title: "標誌與背景圖片",
  image_uploader_subtitle: "圖片設定",
  image_uploader_description:
    "上傳及變更自訂標誌或卡片背景圖片",

  color_palette_subtitle: "自訂外觀",
  color_palette_description:
    "設定標題、背景與文字顏色，以提升可讀性與對比度",
},

edit_video_special_info_single: {
  base_info_title: "資訊",
  base_info_description:
    "編輯標題與 QR Code 位址等基本資訊。",

  image_uploader_title: "上傳標誌",
  image_uploader_description:
    "上傳及管理頁面標誌圖片。",

  video_gallery_title: "影片圖庫",
  video_gallery_description:
    "新增、編輯及管理要顯示於圖庫中的影片。",

  social_media_icons_title: "新增社群網路",
  social_media_icons_description:
    "新增社群媒體連結與聯絡方式。",

  color_palette_title: "選擇顏色",
  color_palette_description:
    "變更配色方案並為頁面選擇合適的色彩主題。",
},

edit_product_special_info_single: {
  factory_info_description:
    "編輯企業資訊與介紹",

  single_product_editor_description:
    "編輯主要資訊與購買等操作按鈕",

  customer_club_settings_description:
    "客戶俱樂部設定與簡訊發送",

  advance_settings_description:
    "進階顯示與安全設定",

  features_description:
    "管理產品特色與技術規格",

  voice_gallery_description:
    "上傳及管理 Podcast 與音訊檔案",

  image_uploader_description:
    "上傳及管理產品圖片圖庫",

  video_gallery_description:
    "新增及管理相關影片圖庫",

  social_media_icons_description:
    "新增及管理社群媒體連結",

  color_palette_description:
    "選擇色彩主題並自訂範本",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "輸入生產企業的一般資訊並進行介紹。",

  single_product_editor_description:
    "設定產品的主要資訊、信任徽章與購買按鈕。",

  customer_club_settings_description:
    "簡訊設定與客戶俱樂部會員設定。",

  features_description:
    "新增產品特色與技術規格。",

  feedback_description:
    "買家評論與回饋區域。",

  consultation_description:
    "諮詢申請或訂單表單。",

  advance_settings_description:
    "進階與智慧產品展示設定。",

  voice_gallery_description:
    "用於產品介紹或指南的音訊檔案。",

  image_uploader_description:
    "上傳產品的不同圖片。",

  video_gallery_description:
    "與產品相關的介紹或教學影片。",

  social_media_icons_description:
    "用於進一步聯絡的社群媒體連結。",

  color_palette_description:
    "設定產品頁面的配色與視覺樣式。",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "音訊圖庫基本資訊與規格",

  image_uploader_description:
    "上傳及管理標誌或封面圖片",

  voice_gallery_description:
    "上傳及管理音訊檔案與 Podcast",

  color_palette_description:
    "選擇色彩主題並自訂圖庫外觀",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "編輯圖庫標題與描述",

  image_uploader_description:
    "上傳及管理標誌與主要封面",

  voice_gallery_acc_description:
    "上傳、刪除及管理音訊檔案",

  social_media_icons_description:
    "新增及管理社群媒體連結",

  color_palette_description:
    "選擇色彩主題並自訂圖庫外觀",
},
edit_bpage_special_info_special: {
  advertising_sites: "廣告網站",
stores: "商店",
divar: "Divar",
divar_hint: "請輸入 Divar 連結",
sheypoor: "Sheypoor",
sheypoor_hint: "請輸入 Sheypoor 連結",
digikala: "Digikala",
digikala_hint: "請輸入 Digikala 連結",
basalam: "Basalam",
basalam_hint: "請輸入 Basalam 連結",
snappshop: "SnappShop",
snappshop_hint: "請輸入 SnappShop 連結",
technolife: "Technolife",
technolife_hint: "請輸入 Technolife 連結",
torob: "Torob",
torob_hint: "請輸入 Torob 連結",
emalls: "eMalls",
emalls_hint: "請輸入 eMalls 連結",
cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "請輸入 Cafe Bazaar 連結",
googleplay: "Google Play",
googleplay_hint: "請輸入 Google Play 連結",
samsung: "三星",
samsung_hint: "請輸入 Galaxy Store 連結",
apple: "Apple",
apple_hint: "請輸入 App Store 連結",
  add_audio_gallery: "新增音訊檔案庫",
  factory_information: "企業資訊",
  trust_badge: "信任徽章",
  buy_button: "購買按鈕",
  smart_settings: "智慧設定",
  add_product_feature: "新增產品特色",
  product_features: "產品特色",
  add_audio_file: "新增音訊檔案",
  audio_gallery: "音訊庫",
  text: "文字",
  logo_background: "標誌 / 背景",
  select_color: "選擇顏色",
  information: "資訊",
  luck_management: "幸運管理",
  registration_management: "註冊管理",
  turning: "翻頁",
  slider: "滑桿",
  vertical: "垂直",
  upload_catalog_brochure_images: "上傳型錄 / 宣傳冊圖片",
  upload_banner: "上傳橫幅",
  upload_header_image: "上傳頁首圖片",
  upload_image: "上傳圖片",
  services: "服務",
  faq: "常見問題",
  blog: "部落格",
  create_product: "建立產品",
  user_information: "使用者資訊",
  add_social_media: "新增社群媒體",
  photo_gallery: "圖片庫",
  video_gallery: "影片庫",
  pdf_gallery: "PDF 檔案庫",
  feedback: "意見回饋",
  request_form: "申請表單",
  create_section: "建立區塊",
  achievements: "成就",
  countdown: "倒數計時",
  team_members: "團隊成員",
  working_hours: "工作時間",
  upload_logo: "上傳標誌",
  create_store: "建立商店",
  customer_club_membership_sms: "客戶俱樂部會員簡訊",
  product_information: "產品資訊",
  asset_management: "資產管理",
  social_media: "社群媒體",
  add_video: "新增影片",
  add_image: "新增圖片",
  add_user_information: "新增使用者資訊",
  manage_accounts: "管理帳戶",
  manage_color: "管理顏色",
  download_qr: "下載 QR 碼",
  add_store: "新增商店",
  manage_appointments: "管理預約",
},
edit_gift_special_info_special: {
  gift_story: "禮物故事",
  profile_image: "個人頭像",
  featured_images: "精選圖片",
  image_gallery: "圖片庫",
  video_gallery: "影片庫",
  add_audio_file: "新增音訊檔案",
  select_color: "選擇顏色",
},
edit_insurance_special_info_special: {
  login_settings: "登入設定",
  shop_logo_images: "商店標誌與圖片",
  login_page_information: "登入頁面資訊",
  upload_banner_logo: "上傳橫幅與標誌",
  user_information: "使用者資訊",
  manage_products_insurance: "管理產品 / 保險",
  special_sale: "特別優惠",
  add_social_media: "新增社群媒體",
  blog: "部落格",
  services: "服務",
  faq: "常見問題",
  photo_gallery: "圖片庫",
  video_gallery: "影片庫",
  pdf_gallery: "PDF 檔案庫",
  feedback: "意見回饋",
  countdown: "倒數計時",
  request_form: "申請表單",
  create_section: "建立區塊",
  achievements: "成就",
  team_members: "團隊成員",
  working_hours: "工作時間",
  shop_login_description: "商店標誌與登入頁面設定",
  insurance_manage_description: "新增與編輯產品 / 服務清單",
  banner_description: "管理頁首圖片",
},
  };
